<template>
  <v-card id="card_map_sailink" class="elevation-0 mt-0 rounded-0">
    <v-card
      id="title_map_sailink"
      class="container_showonmap ma-3 elevation-0 rounded-0 mt-0 pb-3"
      style="border: solid 1px #e0e0e0"
      v-if="showmaptable"
    >
      <v-toolbar color="#F7F7F7" elevation="0" dense>
        {{ showmaptable.vessel_pt }}
        <v-spacer></v-spacer>

        <v-btn small class="elevation-0 rounded-0" icon @click="closeShowMap()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card
        class="flexposisi pa-3 rounded-0"
        height="fit-content"
        elevation="0"
        style="margin-top: 0"
      >
        <v-card
          class="datacard elevation-0 rounded-0"
          color="#F7F7F7"
          elevation="0"
          style="border: solid 1px #e0e0e0"
        >
          <v-simple-table class="elevation-0 rounded-0" dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td class="pl-3">SatNet</td>
                  <td>{{ showmaptable.message.satnet }}</td>
                </tr>
                <tr>
                  <td class="pl-3">Type Terminal</td>
                  <td>{{ showmaptable.device.terminal }}</td>
                </tr>
                <tr>
                  <td class="pl-3">IP Address</td>
                  <td v-if="!ip_adr">Loading...</td>
                  <td v-if="ip_adr">
                    {{ ip_adr.ip_addr }}
                  </td>
                </tr>
                <tr>
                  <td class="pl-3">Link Status</td>
                  <td v-if="!ln_status">
                    <v-chip
                      style="cursor: pointer"
                      small
                      color="#1976D2"
                      text-color="white"
                      >Updating..</v-chip
                    >
                  </td>
                  <td v-if="ln_status">
                    <v-chip
                      v-if="ln_status.status"
                      @click="lnStatus(showmaptable.id)"
                      style="cursor: pointer"
                      small
                      :color="ln_status.status == 'UP' ? '#38C072' : 'red'"
                      text-color="white"
                      ><v-icon x-small>mdi-refresh</v-icon>&nbsp;{{
                        ln_status.status
                      }}</v-chip
                    >
                  </td>
                </tr>
                <tr>
                  <td class="pl-3">RX SNR</td>
                  <td>{{ showmaptable.message.rx_snr }}</td>
                </tr>
                <tr>
                  <td class="pl-3">TX Power</td>
                  <td>{{ showmaptable.message.tx_power }}</td>
                </tr>
                <tr>
                  <td class="pl-3">MODCOD</td>
                  <td>{{ showmaptable.message.modcod }}</td>
                </tr>
                <tr v-if="showmaptable.ip_phones.length != 0">
                  <td class="pl-3">PSTN/MobilePhone</td>
                  <td>
                    <ul style="display: block; margin-left: -1.8em">
                      <li
                        v-for="phones in showmaptable.ip_phones"
                        :key="phones"
                      >
                        +{{ phones.number }} ({{ phones.provider.name }})
                      </li>
                    </ul>
                  </td>
                </tr>

                <tr>
                  <td class="pl-3">Latitude, Longtitude</td>
                  <td>{{ showmaptable.message.latlong }}</td>
                </tr>
                <tr>
                  <td class="pl-3">DMS</td>
                  <td>{{ showmaptable.message.dms }}</td>
                </tr>
                <tr>
                  <td class="pl-3">Last Updated</td>
                  <td>{{ showmaptable.message.last_up }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-simple-table class="elevation-0 rounded-0" dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td colspan="2" class="pa-3 pl-3">
                    <v-chip
                      v-if="showmaptable.band.service_name"
                      class="rounded-0"
                      color="#1976D2"
                      small
                      outlined
                      label
                      >{{ showmaptable.band.service_name }}</v-chip
                    >
                  </td>
                </tr>
                <tr
                  v-if="
                    showmaptable.band.service_name &&
                    showmaptable.band.service_name != 'Services : UNMETERED'
                  "
                >
                  <td class="pl-3">
                    <v-chip
                      class="rounded-0 mr-2"
                      @click="fetchQdialy('metered')"
                      small
                      label
                      style="cursor: pointer"
                      text-color="white"
                      color="primary"
                      ><v-icon small>mdi-chart-bar</v-icon></v-chip
                    ><b>Metered</b>
                  </td>
                  <td></td>
                </tr>
                <tr
                  v-if="
                    showmaptable.band.service_name &&
                    showmaptable.band.service_name != 'Services : UNMETERED'
                  "
                >
                  <td class="pl-3">Quota</td>
                  <td>{{ showmaptable.band.quota }}</td>
                </tr>
                <tr
                  v-if="
                    showmaptable.band.service_name &&
                    showmaptable.band.service_name != 'Services : UNMETERED'
                  "
                >
                  <td class="pl-3">Quota Used</td>
                  <td style="padding-right: 7em">
                    <row>
                      <p style="font-size: 10px; margin-bottom: 0px">
                        {{ showmaptable.band.used }} ({{
                          showmaptable.band.percentage
                        }}
                        %)
                      </p>
                      <v-progress-linear
                        height="10"
                        :value="showmaptable.band.percentage"
                        color="primary"
                      ></v-progress-linear
                    ></row>
                  </td>
                </tr>
                <tr
                  v-if="
                    showmaptable.band.service_name &&
                    showmaptable.band.service_name != 'Services : UNMETERED'
                  "
                >
                  <td class="pl-3">Upload</td>
                  <td>{{ showmaptable.band.m_upload }}</td>
                </tr>
                <tr
                  v-if="
                    showmaptable.band.service_name &&
                    showmaptable.band.service_name != 'Services : UNMETERED'
                  "
                >
                  <td class="pl-3">Download</td>
                  <td>{{ showmaptable.band.m_download }}</td>
                </tr>
                <tr
                  v-if="
                    showmaptable.band.service_name &&
                    showmaptable.band.service_name != 'Services : METERED'
                  "
                >
                  <td class="pl-3">
                    <v-chip
                      @click="fetchQdialy('unmetered')"
                      class="rounded-0 mr-2"
                      small
                      label
                      style="cursor: pointer"
                      text-color="white"
                      color="primary"
                      ><v-icon small>mdi-chart-bar</v-icon></v-chip
                    ><b>Unmetered</b>
                  </td>
                  <td></td>
                </tr>
                <tr
                  v-if="
                    showmaptable.band.service_name &&
                    showmaptable.band.service_name != 'Services : METERED'
                  "
                >
                  <td class="pl-3">Upload</td>
                  <td>{{ showmaptable.band.um_upload }}</td>
                </tr>
                <tr
                  v-if="
                    showmaptable.band.service_name &&
                    showmaptable.band.service_name != 'Services : METERED'
                  "
                >
                  <td class="pl-3">Download</td>
                  <td>{{ showmaptable.band.um_download }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider></v-divider>
          <v-toolbar color="#F7F7F7" dense class="elevation-0 rounded-0"
            >Vessel Images</v-toolbar
          >
          <v-divider></v-divider>
          <v-data-table
            v-if="showmaptable.images"
            :items="showmaptable.images"
            :items-per-page="4"
            class="elevation-0 rounded-0 image imageTable_sailinkdesktop"
            hide-default-footer
            :page.sync="pageImage"
            @page-count="pageCountImage = $event"
          >
            <template v-slot:item="row">
              <tr>
                <td
                  style="
                    background-color: #ffff;
                    padding: 1em;
                    border-bottom: none;
                  "
                >
                  <img
                    @click="(imageOpen = true), (imageOpenData = row.item[0])"
                    :src="row.item[0]"
                    style="
                      cursor: pointer;
                      width: 6em;
                      height: 6em;
                      object-fit: cover;
                    "
                  />
                </td>
              </tr>
            </template>
          </v-data-table>

       
          <v-divider></v-divider>

          <v-toolbar
            v-if="showmaptable.images"
            dense
            class="elevation-0 rounded-0"
            color="#F7F7F7"
          >
            <p class="mt-3" style="font-size: 0.8em">
              Showing 1 to 4 of {{ showmaptable.images.length }} entries
            </p>
            <v-spacer></v-spacer>
            <v-pagination
              dense
              color="primary"
              v-if="showmaptable"
              v-model="pageImage"
              :length="pageCountImage"
              :total-visible="7"
            ></v-pagination>
          </v-toolbar>
        </v-card>

        <v-card
          color="#F7F7F7"
          id="mapcard"
          class="mapcard rounded-0"
          elevation="0"
          style="border: solid 1px #e0e0e0"
        >
          <v-toolbar
            color="#F7F7F7"
            class="rounded-0 toolbar_sailinkdesktop"
            dense
            elevation="0"
          >
            <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  style="border: solid 1px #e0e0e0"
                  class="elevation-0 rounded-0"
                  color="#fff"
                  v-bind="attrs"
                  v-on="on"
                  small
                  elevation="0"
                >
                  <v-icon small>mdi-update</v-icon>
                  &nbsp;
                  <div v-if="!showmaptracking">Loading...</div>
                  <div v-if="showmaptracking">
                    {{ showmaptracking.range.label }}
                  </div>
                  &nbsp;
                  <v-icon small>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list style="border: solid 1px #e0e0e0">
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="showdate(showmaptable.id, 'today')"
                    >Today</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="showdate(showmaptable.id, '24')"
                    >Last 24 Hour</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="showdate(showmaptable.id, '7')"
                    >Last 7 Day</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="showdate(showmaptable.id, '30')"
                    >Last 30 Day</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="showdate(showmaptable.id, 'lmonth')"
                    >Last Month</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="(dateopen = true), (datepickerID = showmaptable.id)"
                    >Custom Range</v-btn
                  >
                </v-list-item>
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>

            <v-chip
              v-if="!showmaptracking"
              style="border: solid 1px #e0e0e0"
              color="#ffff"
              class="rounded-0"
              label
              ><v-icon small class="mr-1">mdi-calendar</v-icon>- - -</v-chip
            >
            <v-chip
              style="border: solid 1px #e0e0e0"
              color="#ffff"
              class="rounded-0"
              v-if="showmaptracking"
              label
              ><v-icon small class="mr-1">mdi-calendar</v-icon
              >{{ showmaptracking.range.actual }}</v-chip
            >
          </v-toolbar>
          <v-card
            color="#F7F7F7"
            class="rounded-0 toolbar_sailinkmobile"
            elevation="0"
          >
            <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  block
                  style="border: solid 1px #e0e0e0"
                  class="elevation-0 rounded-0"
                  color="#fff"
                  v-bind="attrs"
                  v-on="on"
                  small
                  elevation="0"
                >
                  <v-icon small>mdi-update</v-icon>
                  &nbsp;
                  <div v-if="!showmaptracking">Loading...</div>
                  <div v-if="showmaptracking">
                    {{ showmaptracking.range.label }}
                  </div>
                  &nbsp;
                  <v-icon small>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list style="border: solid 1px #e0e0e0">
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="showdate(showmaptable.id, 'today')"
                    >Today</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="showdate(showmaptable.id, '24')"
                    >Last 24 Hour</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="showdate(showmaptable.id, '7')"
                    >Last 7 Day</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="showdate(showmaptable.id, '30')"
                    >Last 30 Day</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="showdate(showmaptable.id, 'lmonth')"
                    >Last Month</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="(dateopen = true), (datepickerID = showmaptable.id)"
                    >Custom Range</v-btn
                  >
                </v-list-item>
              </v-list>
            </v-menu>

            <v-chip
              x-small
              v-if="!showmaptracking"
              style="border: solid 1px #e0e0e0"
              color="#ffff"
              class="rounded-0"
              label
              >- - -</v-chip
            >
            <v-chip
              x-small
              style="border: solid 1px #e0e0e0"
              color="#ffff"
              class="rounded-0 pa-0"
              v-if="showmaptracking"
              label
              >{{ showmaptracking.range.actual }}</v-chip
            >
          </v-card>
          <v-divider></v-divider>
          <v-container
            v-if="!showmaptracking"
            id="map_sailink"
            fill-height
            fluid
            style="margin-top: 0; height: 35em; background-color: #aad3df"
          >
            <v-row align="center" justify="center">
              <v-col
                ><img
                  alt="Navplus logo"
                  width="70px"
                  :src="loadernavplus"
                  class="justify-center"
              /></v-col>
            </v-row>
          </v-container>

          <l-map
            id="map_sailink_"
            v-if="showmaptracking"
            @fullscreenchange="triggerFullscreen"
            @polylinemeasure:add="onCount"
            @polylinemeasure:remove="onCount"
            @polylinemeasure:toggle="handleToggle"
            @polylinemeasure:finish="handleFinish"
            style="height: 45em"
            zoom="6"
            ref="map_sailink"
            :center="[
              parseFloat(showmaptracking.maptop.lat),
              parseFloat(showmaptracking.maptop.lon),
            ]"
            :options="{
              minZoom: 3,
              zoomControl: false,
              doubleClickZoom: true,
              scrollWheelZoom: false,
            }"
          >
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            <l-control-zoom position="bottomright"></l-control-zoom>
            <l-control-fullscreen
              position="bottomright"
              :options="{ title: { false: 'Go big!', true: 'Be regular' } }"
            />
            <l-control-polyline-measure
              v-if="etaControl"
              :ref="'polylineMeasure'"
              :options="{
                showUnitControl: false,
                showClearControl: false,
                showBearings: true,
                unit: unit,
                clearMeasurementsOnStop: false,
                measureControlClasses: ['hideControl'], // Classes to apply to the Measure Control
              }"
              v-model="measurepoly"
              position="bottomright"
            />

            <v-rotated-marker
              :lat-lng="[
                parseFloat(showmaptracking.maptop.lat),
                parseFloat(showmaptracking.maptop.lon),
              ]"
              :rotationAngle="parseInt(showmaptracking.maptop.heading)"
            >
              <l-icon
                :icon-size="[40 / 4, 100 / 4]"
                :icon-anchor="[40 / 4 / 2, 100 / 4 / 2]"
                class-name="someExtraClass"
              >
                <svg
                  id="a"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 40 100"
                >
                  <path
                    :fill="showmaptracking.maptop.fill"
                    stroke="#FFF"
                    stroke-width="10"
                    d="M37.93,32.68L20,0,2.07,32.68c-1.35,2.45-2.07,5.41-2.07,8.44v57.33c0-11.59,8.95-20.99,20-20.99s20,9.4,20,20.99V41.12c0-3.03-.72-5.98-2.07-8.44Z"
                  />
                </svg>
              </l-icon>
              <l-popup @ready="draw_Circle(),movingStart()">
                <table>
                  <tr>
                    <td><b>Latitude</b></td>
                    <td>:</td>
                    <td>
                      {{ showmaptracking.maptop.lat }}
                    </td>
                  </tr>
                  <tr>
                    <td><b>Longitude</b></td>
                    <td>:</td>
                    <td>{{ showmaptracking.maptop.lon }}</td>
                  </tr>
                  <tr>
                    <td><b>DMS</b></td>
                    <td>:</td>
                    <td>{{ showmaptracking.maptop.dms }}</td>
                  </tr>
                  <tr>
                    <td><b>Speed</b></td>
                    <td>:</td>
                    <td>
                      {{ showmaptracking.maptop.speed + "&nbsp;knots" }}
                    </td>
                  </tr>
                  <tr>
                    <td><b>Heading</b></td>
                    <td>:</td>
                    <td>{{ showmaptracking.maptop.heading + "&deg;" }}</td>
                  </tr>
                  <tr>
                    <td><b>Last Update</b></td>
                    <td>:</td>
                    <td>{{ showmaptracking.maptop.lastUp }}</td>
                  </tr>
                </table>
                <table>
                  <tr>
                    <td><b>SatNet</b></td>
                    <td><b>:</b></td>
                    <td>
                      <b>{{ showmaptracking.maptop.satnet }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>EIRP</td>
                    <td>:</td>
                    <td>{{ showmaptracking.maptop.satnet }}</td>
                  </tr>
                  <tr>
                    <td>G/T+</td>
                    <td>:</td>
                    <td>{{ showmaptracking.maptop.satnet }}</td>
                  </tr>
                </table>
              </l-popup>
            </v-rotated-marker>

            <l-moving-rotated-marker 
        
            ref="driveMarker"
           
            :lat-lng="driveLatLng"
        :rotationAngle="driveRotationAngle"
        :duration="3000"
        :icon="icon"
      />

            <!-- <l-control position="topleft" style="margin-left: -0.2em">
   
    </l-control> -->

            <!--EIRP-->
            <div v-if="SKYR1 && EIRP">
              <l-polygon
                :key="sky1"
                v-for="(m, sky1) in paths_cns11"
                :lat-lngs="m"
                :color="polygon.skyr1"
                :weight="0.8"
                :opacity="0.9"
                :fillOpacity="0.03"
                :fillColor="polygon.skyr1"
              >
                <l-popup @change="console.log('OKAY')">
                  <div id="content">
                    <div class="popup_polygon">
                      <img
                        :src="satellite"
                        alt="loading"
                        style="
                          height: 25px;
                          margin-top: 20px;
                          margin-right: 10px;
                        "
                      />
                      <div style="text-align: left; margin-top: 20px">
                        <strong>SatNet : Skyreach1</strong><br />
                        <strong>Level: {{ gain_cns11[sky1] }}</strong
                        ><br />
                        <strong>[{{ sky1 }}]</strong>
                      </div>
                    </div>
                  </div>
                </l-popup>
              </l-polygon>
            </div>

            <div v-if="SKYR2 && EIRP">
              <l-polygon
                :key="sky2"
                v-for="(m, sky2) in paths_apstar5"
                :lat-lngs="m"
                :color="polygon.skyr2"
                :weight="0.8"
                :opacity="0.9"
                :fillOpacity="0.03"
                :fillColor="polygon.skyr2"
              >
                <l-popup @change="console.log('OKAY')">
                  <div id="content">
                    <div class="popup_polygon">
                      <img
                        :src="satellite"
                        alt="loading"
                        style="
                          height: 25px;
                          margin-top: 20px;
                          margin-right: 10px;
                        "
                      />
                      <div style="text-align: left; margin-top: 20px">
                        <strong>SatNet : Skyreach2</strong><br />
                        <strong>Level: {{ gain_apstar5[sky2] }}</strong
                        ><br />
                        <strong>[{{ sky2 }}]</strong>
                      </div>
                    </div>
                    <!-- <div style="text-align:left;margin-top:20px;background-color:#EAE9FC;padding:4px;padding-bottom:0px;border-radius:3px">
    
    <p>Lat,lon 
    </p>
    </div> -->
                  </div>
                </l-popup>
              </l-polygon>
            </div>
            <div v-if="APST9 && EIRP">
              <l-polygon
                :key="apst9"
                v-for="(m, apst9) in paths_apstar9"
                :lat-lngs="m"
                :color="polygon.apst9"
                :weight="0.8"
                :opacity="0.9"
                :fillOpacity="0.03"
                :fillColor="polygon.apst9"
              >
                <l-popup @change="console.log('OKAY')">
                  <div id="content">
                    <div class="popup_polygon">
                      <img
                        :src="satellite"
                        alt="loading"
                        style="
                          height: 25px;
                          margin-top: 20px;
                          margin-right: 10px;
                        "
                      />
                      <div style="text-align: left; margin-top: 20px">
                        <strong>SatNet : Apstar 9</strong><br />
                        <strong>Level: {{ gain_apstar9[apst9] }}</strong
                        ><br />
                        <strong>[{{ apst9 }}]</strong>
                      </div>
                    </div>
                    <!-- <div style="text-align:left;margin-top:20px;background-color:#EAE9FC;padding:4px;padding-bottom:0px;border-radius:3px">
    
    <p>Lat,lon 
    </p>
    </div> -->
                  </div>
                </l-popup>
              </l-polygon>
            </div>
            <div v-if="ABS2A && EIRP">
              <l-polygon
                :key="abs"
                v-for="(m, abs) in paths_abs"
                :lat-lngs="m"
                :color="polygon.abs2a"
                :weight="0.8"
                :opacity="0.9"
                :fillOpacity="0.03"
                :fillColor="polygon.abs2a"
              >
                <l-popup>
                  <div id="content1">
                    <div class="popup_polygon">
                      <img
                        :src="satellite"
                        alt="loading"
                        style="
                          height: 25px;
                          margin-top: 20px;
                          margin-right: 10px;
                        "
                      />
                      <div style="text-align: left; margin-top: 20px">
                        <strong>SatNet : Abs 2A</strong><br />
                        <strong>Level: {{ gain_abs[abs] }}</strong
                        ><br />
                        <strong>[{{ abs }}]</strong>
                      </div>
                    </div>
                    <!-- <div style="text-align:left;margin-top:20px;background-color:#EAE9FC;padding:4px;padding-bottom:0px;border-radius:3px">
    
    <p>Lat,lon 
    </p>
    </div> -->
                  </div>
                </l-popup>
              </l-polygon>
            </div>

            <div v-if="SR1MR && EIRP">
              <l-polygon
                :key="ocn"
                v-for="(m, ocn) in paths_ocn"
                :lat-lngs="m"
                :color="polygon.sr1mr"
                :weight="0.8"
                :opacity="0.9"
                :fillOpacity="0.03"
                :fillColor="polygon.sr1mr"
              >
                <l-popup @change="console.log('OKAY')">
                  <div id="content">
                    <div class="popup_polygon">
                      <img
                        :src="satellite"
                        alt="loading"
                        style="
                          height: 25px;
                          margin-top: 20px;
                          margin-right: 10px;
                        "
                      />
                      <div style="text-align: left; margin-top: 20px">
                        <strong>SatNet : SR1 Maritime</strong><br />
                        <strong>Level: {{ gain_ocn[ocn] }}</strong
                        ><br />
                        <strong>[{{ ocn }}]</strong>
                      </div>
                    </div>
                    <!-- <div style="text-align:left;margin-top:20px;background-color:#EAE9FC;padding:4px;padding-bottom:0px;border-radius:3px">
    
    <p>Lat,lon 
    </p>
    </div> -->
                  </div>
                </l-popup>
              </l-polygon>
            </div>

            <!--GNT-->
            <div v-if="SKYR1 && GNT">
              <l-polygon
                :key="sky1gnt"
                v-for="(m, sky1gnt) in paths_cns11gnt"
                :lat-lngs="m"
                :color="polygon.skyr1"
                :weight="0.8"
                :opacity="0.9"
                :fillOpacity="0.03"
                :fillColor="polygon.skyr1"
              >
                <l-popup @change="console.log('OKAY')">
                  <div id="content">
                    <div class="popup_polygon">
                      <img
                        :src="satellite"
                        alt="loading"
                        style="
                          height: 25px;
                          margin-top: 20px;
                          margin-right: 10px;
                        "
                      />
                      <div style="text-align: left; margin-top: 20px">
                        <strong>SatNet : Skyreach1</strong><br />
                        <strong>Level: {{ gain_cns11gnt[sky1gnt] }}</strong
                        ><br />
                        <strong>[{{ sky1gnt }}]</strong>
                      </div>
                    </div>
                  </div>
                </l-popup>
              </l-polygon>
            </div>

            <div v-if="SKYR2 && GNT">
              <l-polygon
                :key="sky2gnt"
                v-for="(m, sky2gnt) in paths_apstar5gnt"
                :lat-lngs="m"
                :color="polygon.skyr2"
                :weight="0.8"
                :opacity="0.9"
                :fillOpacity="0.03"
                :fillColor="polygon.skyr2"
              >
                <l-popup @change="console.log('OKAY')">
                  <div id="content">
                    <div class="popup_polygon">
                      <img
                        :src="satellite"
                        alt="loading"
                        style="
                          height: 25px;
                          margin-top: 20px;
                          margin-right: 10px;
                        "
                      />
                      <div style="text-align: left; margin-top: 20px">
                        <strong>SatNet : Skyreach2</strong><br />
                        <strong>Level: {{ gain_apstar5gnt[sky2gnt] }}</strong
                        ><br />
                        <strong>[{{ sky2gnt }}]</strong>
                      </div>
                    </div>
                  </div>
                </l-popup>
              </l-polygon>
            </div>

            <div v-if="APST9 && GNT">
              <l-polygon
                :key="apst9gnt"
                v-for="(m, apst9gnt) in paths_apstar9gnt"
                :lat-lngs="m"
                :color="polygon.apst9"
                :weight="0.8"
                :opacity="0.9"
                :fillOpacity="0.03"
                :fillColor="polygon.apst9"
              >
                <l-popup @change="console.log('OKAY')">
                  <div id="content">
                    <div class="popup_polygon">
                      <img
                        :src="satellite"
                        alt="loading"
                        style="
                          height: 25px;
                          margin-top: 20px;
                          margin-right: 10px;
                        "
                      />
                      <div style="text-align: left; margin-top: 20px">
                        <strong>SatNet : Apstar 9</strong><br />
                        <strong>Level: {{ gain_apstar9gnt[apst9gnt] }}</strong
                        ><br />
                        <strong>[{{ apst9gnt }}]</strong>
                      </div>
                    </div>
                  </div>
                </l-popup>
              </l-polygon>
            </div>

            <div v-if="ABS2A && GNT">
              <l-polygon
                :key="absgnt"
                v-for="(m, absgnt) in paths_absgnt"
                :lat-lngs="m"
                :color="polygon.abs2a"
                :weight="0.8"
                :opacity="0.9"
                :fillOpacity="0.03"
                :fillColor="polygon.abs2a"
              >
                <l-popup @change="console.log('OKAY')">
                  <div id="content">
                    <div class="popup_polygon">
                      <img
                        :src="satellite"
                        alt="loading"
                        style="
                          height: 25px;
                          margin-top: 20px;
                          margin-right: 10px;
                        "
                      />
                      <div style="text-align: left; margin-top: 20px">
                        <strong>SatNet : ABS 2A</strong><br />
                        <strong>Level: {{ gain_absgnt[absgnt] }}</strong
                        ><br />
                        <strong>[{{ absgnt }}]</strong>
                      </div>
                    </div>
                  </div>
                </l-popup>
              </l-polygon>
            </div>

            <div v-if="SR1MR && GNT">
              <l-polygon
                :key="ocngnt"
                v-for="(m, ocngnt) in paths_ocngnt"
                :lat-lngs="m"
                :color="polygon.sr1mr"
                :weight="0.8"
                :opacity="0.9"
                :fillOpacity="0.03"
                :fillColor="polygon.sr1mr"
              >
                <l-popup @change="console.log('OKAY')">
                  <div id="content">
                    <div class="popup_polygon">
                      <img
                        :src="satellite"
                        alt="loading"
                        style="
                          height: 25px;
                          margin-top: 20px;
                          margin-right: 10px;
                        "
                      />
                      <div style="text-align: left; margin-top: 20px">
                        <strong>SatNet : SR1 Maritime</strong><br />
                        <strong>Level: {{ gain_ocngnt[ocngnt] }}</strong
                        ><br />
                        <strong>[{{ ocngnt }}]</strong>
                      </div>
                    </div>
                  </div>
                </l-popup>
              </l-polygon>
            </div>

            <!-- <l-polyline
              :key="line.id"
              v-for="line in showmaptracking.tracking"
              :lat-lngs="showmaptracking.tracking"
              :color="'#48C67D'"
            ></l-polyline> -->

            <!-- <l-circle
              v-for="circle in showmaptracking.tracking"
              :key="circle.id"
              :lat-lng="{
                lat: parseFloat(circle.lat),
                lng: parseFloat(circle.lng),
              }"
              :radius="2500"
              :color="'blue'"
              ><l-popup>
                <table>
                  <tr>
                    <td><b>Latitude</b></td>
                    <td>:</td>
                    <td>
                      {{ circle.lat }}
                    </td>
                  </tr>
                  <tr>
                    <td><b>Longitude</b></td>
                    <td>:</td>
                    <td>{{ circle.lng }}</td>
                  </tr>
                  <tr>
                    <td><b>DMS</b></td>
                    <td>:</td>
                    <td>{{ circle.dms }}</td>
                  </tr>
                  <tr>
                    <td><b>Speed</b></td>
                    <td>:</td>
                    <td>{{ circle.speed + "&nbsp;knots" }}</td>
                  </tr>
                  <tr>
                    <td><b>Heading</b></td>
                    <td>:</td>
                    <td>{{ circle.heading + "&deg;" }}</td>
                  </tr>
                  <tr>
                    <td><b>Last Update</b></td>
                    <td>:</td>
                    <td>{{ circle.updated }}</td>
                  </tr>
                </table>
              </l-popup></l-circle
            > -->
            <l-control
              class="lmapbtn_sailinkmobile"
              position="topright"
              style="display: flex; justify-content: space-between"
            >
              <div class="lmapbtn_sailinkmobile">
                <v-expansion-panels
                  class="elevation-0 rounded-0"
                  style="width: 35vw"
                >
                  <v-expansion-panel
                    v-if="
                      user_allowed.role_id == 2 || user_allowed.role_id == 5
                    "
                    class="elevation-0 rounded-0 pa-0"
                  >
                    <v-expansion-panel-header
                      class="elevation-0 rounded-0 pa-1 ma-1"
                      style="height: 2em"
                      >SatNet</v-expansion-panel-header
                    >
                    <v-expansion-panel-content
                      class="elevation-0 rounded-0 pa-0"
                      width="20"
                      style="text-align: left"
                    >
                      <div class="uper_li" @click="EIRP = !EIRP">
                        <input
                          type="checkbox"
                          v-model="EIRP"
                          value="EIRP"
                        />&nbsp;EIRP
                      </div>
                      <div class="uper_li" @click="GNT = !GNT">
                        <input
                          type="checkbox"
                          v-model="GNT"
                          value="GNT"
                        />&nbsp;G/T+
                      </div>
                      <div class="divider"></div>
                      <div
                        class="bot_li"
                        @click="
                          !EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP'),
                            (SKYR1 = !SKYR1)
                        "
                      >
                        <input
                          type="checkbox"
                          v-model="SKYR1"
                          value="SKYR1"
                          @change="
                            !EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP')
                          "
                        />&nbsp;Skyreach 1
                      </div>
                      <div
                        class="bot_li"
                        @click="
                          !EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP'),
                            (SKYR2 = !SKYR2)
                        "
                      >
                        <input
                          type="checkbox"
                          v-model="SKYR2"
                          value="SKYR2"
                          @change="
                            !EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP')
                          "
                        />&nbsp;Skyreach 2
                      </div>
                      <div
                        class="bot_li"
                        @click="
                          !EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP'),
                            (APST9 = !APST9)
                        "
                      >
                        <input
                          type="checkbox"
                          v-model="APST9"
                          value="APST9"
                          @change="
                            !EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP')
                          "
                        />&nbsp;Apstar 9
                      </div>
                      <div
                        class="bot_li"
                        @click="
                          !EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP'),
                            (ABS2A = !ABS2A)
                        "
                      >
                        <input
                          type="checkbox"
                          v-model="ABS2A"
                          value="ABS2A"
                          @change="
                            !EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP')
                          "
                        />&nbsp;ABS 2A
                      </div>
                      <div
                        class="bot_li"
                        @click="
                          !EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP'),
                            (SR1MR = !SR1MR)
                        "
                      >
                        <input
                          type="checkbox"
                          v-model="SR1MR"
                          value="SR1MR"
                          @change="
                            !EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP')
                          "
                        />&nbsp;SR1 Maritime
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </l-control>
            <l-control
              position="topleft"
              style="display: flex; justify-content: space-between"
            >
              <div class="lmapbtn_sailinkmobile">
                <v-expansion-panels
                  class="elevation-0 rounded-0"
                  style="width: 35vw"
                >
                  <v-expansion-panel v-if="!etaControl">
                    <v-btn
                      style="text-align: left"
                      small
                      color="primary"
                      @click="
                        etaControl ? console.log('Already Open') : openETA()
                      "
                      block
                      class="elevation-0 rounded-0"
                      >ETA</v-btn
                    >
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
              <div class="btneta_sailinkdesktop">
                <v-btn
                  v-if="!etaControl"
                  elevation="0"
                  class="rounded-0 pa-1"
                  height="31"
                  width="50"
                  dark
                  :color="etaControl ? '#95BADF' : 'primary'"
                  @click="etaControl ? console.log('Already Open') : openETA()"
                >
                  <v-icon small>mdi-map-marker-distance</v-icon>
                  &nbsp; ETA
                </v-btn>
              </div>
              <div
                class="satnetbtn_sailinkdesktop"
                v-if="user_allowed.role_id == 2 || user_allowed.role_id == 5"
              >
                <label class="dropdown">
                  <div class="dd-button">
                    <v-icon>mdi-satellite-variant</v-icon>
                    <v-text style="margin-top: 0.3em">SatNet</v-text>
                    <v-icon>mdi-chevron-down</v-icon>
                  </div>
                  <input type="checkbox" class="dd-input" />

                  <ul class="dd-menu">
                    <li class="uper_li" @click="EIRP = !EIRP">
                      <input
                        type="checkbox"
                        v-model="EIRP"
                        value="EIRP"
                      />&nbsp;EIRP
                    </li>
                    <li class="uper_li" @click="GNT = !GNT">
                      <input
                        type="checkbox"
                        v-model="GNT"
                        value="GNT"
                      />&nbsp;G/T+
                    </li>
                    <li class="divider"></li>
                    <li
                      class="bot_li"
                      @click="
                        !EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP'),
                          (SKYR1 = !SKYR1)
                      "
                    >
                      <input
                        type="checkbox"
                        v-model="SKYR1"
                        value="SKYR1"
                        @change="!EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP')"
                      />&nbsp;Skyreach 1
                    </li>
                    <li
                      class="bot_li"
                      @click="
                        !EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP'),
                          (SKYR2 = !SKYR2)
                      "
                    >
                      <input
                        type="checkbox"
                        v-model="SKYR2"
                        value="SKYR2"
                        @change="!EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP')"
                      />&nbsp;Skyreach 2
                    </li>
                    <li
                      class="bot_li"
                      @click="
                        !EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP'),
                          (APST9 = !APST9)
                      "
                    >
                      <input
                        type="checkbox"
                        v-model="APST9"
                        value="APST9"
                        @change="!EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP')"
                      />&nbsp;Apstar 9
                    </li>
                    <li
                      class="bot_li"
                      @click="
                        !EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP'),
                          (ABS2A = !ABS2A)
                      "
                    >
                      <input
                        type="checkbox"
                        v-model="ABS2A"
                        value="ABS2A"
                        @change="!EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP')"
                      />&nbsp;ABS 2A
                    </li>
                    <li
                      class="bot_li"
                      @click="
                        !EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP'),
                          (SR1MR = !SR1MR)
                      "
                    >
                      <input
                        type="checkbox"
                        v-model="SR1MR"
                        value="SR1MR"
                        @change="!EIRP && GNT ? (EIRP = null) : (EIRP = 'EIRP')"
                      />&nbsp;SR1 Maritime
                    </li>
                  </ul>
                </label>
              </div>
            </l-control>
            <l-control position="topright">
              <v-card
                width="300"
                class="elevation-0 rounded-0 coordinate_sailinkdesktop"
                max-height="800"
                style="overflow-y: auto; margin-left: 1em"
                v-show="showRoute"
              >
                <v-toolbar class="elevation-0 rounded-0" color="#f7f7f7" dense
                  ><v-spacer
                    ><v-toolbar-title>Coordinates</v-toolbar-title></v-spacer
                  >
                </v-toolbar>

                <v-data-table
                  v-if="!showRouteData"
                  :headers="headersRoute"
                  :items="showRouteEmpty"
                  :items-per-page="itemsPerPageCoordinate"
                  :page.sync="pageCoordinate"
                  hide-default-footer
                  class="elevation-0 routeTable"
                  @page-count="pageCountCoordinate = $event"
                  ><template v-slot:item="row">
                    <tr>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; text-align: center"
                      >
                        {{ row.item.index }}
                      </td>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; text-align: center"
                      >
                        {{ row.item.lat }}
                      </td>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; text-align: center"
                      >
                        {{ row.item.br }}
                      </td>
                    </tr></template
                  ></v-data-table
                >
                <v-data-table
                  v-if="showRouteData"
                  :headers="headersRoute"
                  :items="showRouteData"
                  hide-default-footer
                  :page.sync="pageCoordinate"
                  :items-per-page="itemsPerPageCoordinate"
                  class="elevation-0 routeTable"
                  @page-count="pageCountCoordinate = $event"
                  ><template v-slot:item="row">
                    <tr>
                      <td
                        class="pa-0"
                        style="white-space: nowrap; text-align: center"
                      >
                        {{ row.item.index + 1 }}
                      </td>
                      <td class="pa-0" style="text-align: center">
                        {{ convertDMS(row.item.lat, row.item.lng).split("-")[0]
                        }}<br />
                        {{
                          convertDMS(row.item.lat, row.item.lng).split("-")[1]
                        }}
                      </td>
                      <td
                        class="pa-0"
                        style="text-align: center"
                        v-if="brRouteData"
                      >
                        {{
                          brRouteData[row.item.index]._icon.childNodes[4]
                            .innerText
                        }}
                        &nbsp;/&nbsp;
                        {{
                          brRouteData[
                            row.item.index
                          ]._icon.childNodes[0].data.split(" ")[1]
                        }}
                      </td>
                      <td class="pa-0" v-else></td></tr></template
                ></v-data-table>
                <v-toolbar
                  v-if="showRouteData"
                  dense
                  class="elevation-0 rounded-0"
                  color="#F7F7F7"
                >
                  <p class="mt-3" style="font-size: 0.8em">
                    Showing 1 to {{ itemsPerPageCoordinate }} of
                    {{ showRouteData.length }} entries
                  </p>
                  <v-spacer></v-spacer>
                  <v-pagination
                    dense
                    color="primary"
                    v-model="pageCoordinate"
                    :length="pageCountCoordinate"
                    :total-visible="7"
                  ></v-pagination>
                </v-toolbar>
              </v-card>
              <v-card
                width="180"
                class="elevation-0 rounded-0 coordinate_sailinkmobile"
                max-height="800"
                style="overflow-y: auto; margin-left: 1em"
                v-show="showRoute"
              >
                <v-toolbar class="elevation-0 rounded-0" color="#f7f7f7" dense
                  ><v-spacer
                    >Coordinates</v-spacer
                  >
                </v-toolbar>

                <v-data-table
                  v-if="!showRouteData"
                  :headers="headersRoute"
                  :items="showRouteEmpty"
                  :items-per-page="3"
                  :page.sync="pageCoordinate"
                  hide-default-footer
                  hide-default-header
                  class="elevation-0 routeTable"
                  @page-count="pageCountCoordinate = $event"
                  ><template v-slot:item="row">
                    <tr>
                      <td>
                       <v-card class="elevation-0 rounded-0">
                        <table>
                          <tr><td>#</td><td>:</td><td
                        class="pa-0"
                        style="white-space: nowrap; text-align: left"
                      >
                        {{ row.item.index }}
                      </td></tr>
                      <tr> <td>Lat/Lng</td><td>:</td><td
                        class="pa-0"
                        style="white-space: nowrap; text-align: left"
                      >
                        {{ row.item.lat }}
                      </td></tr>
                         <tr><td>Dist/Brng</td><td>:</td><td
                        class="pa-0"
                        style="white-space: nowrap; text-align: left"
                      >
                        {{ row.item.br }}
                      </td></tr> 
                      
                     
                        </table>
                       </v-card>
                      </td>
                    </tr></template
                  ></v-data-table
                >
                <v-data-table
                  v-if="showRouteData"
                  :headers="headersRoute"
                  :items="showRouteData"
                  hide-default-footer
                  hide-default-header
                  :page.sync="pageCoordinate"
                  :items-per-page="2"
                  class="elevation-0 routeTable"
                  @page-count="pageCountCoordinate = $event"
                  ><template v-slot:item="row">
                    <tr>
                      <td>
                       <v-card class="elevation-0 rounded-0">
                        <table>
                          <tr><td>#</td><td>:</td><td
                        class="pa-0"
                        style="white-space: nowrap; text-align: left"
                      >
                        {{ row.item.index + 1 }}
                      </td></tr>
                      <tr> <td>Lat/Lng</td><td>:</td><td class="pa-0" style="text-align: left">
                        {{ convertDMS(row.item.lat, row.item.lng).split("-")[0]
                        }}<br />
                        {{
                          convertDMS(row.item.lat, row.item.lng).split("-")[1]
                        }}
                      </td></tr>
                         <tr><td>Dist/Brng</td><td>:</td><td
                        class="pa-0"
                        style="text-align: left"
                        v-if="brRouteData"
                      >
                        {{
                          brRouteData[row.item.index]._icon.childNodes[4]
                            .innerText
                        }}
                        &nbsp;/&nbsp;
                        {{
                          brRouteData[
                            row.item.index
                          ]._icon.childNodes[0].data.split(" ")[1]
                        }}
                      </td><td class="pa-0" v-else></td></tr> 
                      
                     
                        </table>
                       </v-card>
                      </td>
                    </tr>
                   
                     
                    
                      
                      </template
                ></v-data-table>
                <v-toolbar
                  v-if="showRouteData"
                  dense
                  class="elevation-0 rounded-0"
                  color="#F7F7F7"
                >
                  <v-spacer></v-spacer>
                  <v-pagination
                    dense
                    color="primary"
                    v-model="pageCoordinate"
                    :length="pageCountCoordinate"
                    :total-visible="7"
                  ></v-pagination>
                </v-toolbar>
              </v-card>
            </l-control>
            <l-control position="bottomleft" style="display: flex">
              <v-card
                class="elevation-0 rounded-0 ETAcard_sailinkdesktop"
                v-show="etaControl"
                height="fit-content"
                width="400"
              >
                <v-toolbar class="elevation-0 rounded-0" dense color="#F7F7F7">
                  <v-btn
                    id="strDraw_btn"
                    class="elevation-0 rounded-0"
                    :color="drawon ? '#95BADF' : 'primary'"
                    small
                    dark
                    @click="startDraw()"
                    >START DRAW</v-btn
                  >
                  <v-btn
                    class="elevation-0 rounded-0 ml-1"
                    color="primary"
                    small
                    dark
                    @click="clearMeasure()"
                    >CLEAR</v-btn
                  >
                  <v-btn
                    dark
                    class="elevation-0 rounded-0 ml-1"
                    color="primary"
                    small
                    @click="onCount()"
                    >COUNT</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    class="elevation-0 rounded-0"
                    fab
                    x-small
                    color="#f7f7f7"
                    @click="
                      (etaControl = false),
                        (drawon = false),
                        clearMeasure(),
                        (totalDistance = 0),
                        (ex25 = false),
                        closeETA(),
                        (showRoute = false)
                    "
                  >
                    <v-icon dark> mdi-close </v-icon>
                  </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-toolbar
                  class="elevation-0 pa-0"
                  dense
                  color="#ffff"
                  style="display: flex"
                >
                  <div style="margin-left: -1.5em; display: flex">
                    <v-checkbox
                      v-model="ex25"
                      label=""
                      class="mx-0"
                      color="primary"
                      hide-details
                    ></v-checkbox>
                    <div
                      style="
                        font-size: 1.2em;
                        margin-left: -1em;
                        margin-top: 1.3em;
                      "
                    >
                      Start From Marker
                    </div>
                    <v-spacer style="width: 1em"></v-spacer>
                    <v-checkbox
                      v-model="showRoute"
                      label=""
                      color="primary"
                      value="red darken-3"
                      hide-details
                    ></v-checkbox>
                    <div
                      style="
                        font-size: 1.2em;
                        margin-left: -1em;
                        margin-top: 1.3em;
                      "
                    >
                      Show Route Detail
                    </div>
                  </div>
                </v-toolbar>
                <v-divider></v-divider>
                <div style="padding: 0.5em">
                  <v-list style="margin: auto">
                    <v-list-item>
                      <v-list-item-content style="text-align: left">
                        <table>
                          <tr>
                            <td>
                              <h3 style="font-size: 1.2em">Total Distance</h3>
                            </td>
                            <td><h3 style="font-size: 1.2em">:</h3></td>
                            <td>
                              <h3 style="font-size: 1.2em">
                                {{ etaMiles }}&nbsp;Nmi
                              </h3>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h3 style="font-size: 1.2em">Duration</h3>
                            </td>
                            <td><h3 style="font-size: 1.2em">:</h3></td>
                            <td>
                              <h3 style="font-size: 1.2em">
                                {{ etaDuration }}&nbsp;Hours
                              </h3>
                            </td>
                          </tr>
                          <tr>
                            <td><h3 style="font-size: 1.2em">Speed</h3></td>
                            <td><h3 style="font-size: 1.2em">:</h3></td>
                            <td>
                              <h3 style="font-size: 1.2em">
                                <input
                                  style="
                                    width: 11em;
                                    background-color: #d5e6f7;
                                    padding: 0.2em;
                                    margin-right: 0.1em;
                                    cursor: pointer;
                                  "
                                  v-model="etaSpeed"
                                  type="number"
                                  v-on:input="countETA()"
                                />&nbsp;Knots
                              </h3>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h3 style="font-size: 1.2em">Depature</h3>
                            </td>
                            <td><h3 style="font-size: 1.2em">:</h3></td>
                            <td>
                              <h3 style="font-size: 1.2em">
                                <input
                                  style="
                                    width: 11em;
                                    background-color: #d5e6f7;
                                    padding: 0.2em;
                                    margin-right: 0.1em;
                                    cursor: pointer;
                                  "
                                  type="datetime-local"
                                  id="departure-sailink"
                                  name="departure-form"
                                  v-on:input="countETA()"
                                />
                                <span id="depart-container"></span>&nbsp;WIB
                              </h3>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <h3 style="font-size: 1.2em">Arrival</h3>
                            </td>
                            <td><h3 style="font-size: 1.2em">:</h3></td>
                            <td>
                              <h3 style="font-size: 1.2em">
                                <input
                                  style="
                                    width: 11em;
                                    background-color: #f7f7f7;
                                    padding: 0.2em;
                                    margin-right: 0.1em;
                                    cursor: auto;
                                  "
                                  type="text"
                                  readonly
                                  :value="etaArrival"
                                />&nbsp;WIB
                              </h3>
                            </td>
                          </tr>
                        </table>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>

                <span class="d-none" id="depart-input-container"></span>
              </v-card>
                 <v-card
                 style="margin-bottom:1.4em"
                class="elevation-0 rounded-0 ETAcard_sailinkmobile"
                v-show="etaControl"
                height="fit-content"
                width="300"
              >
                <v-toolbar class="elevation-0 rounded-0" dense color="#F7F7F7">
                  <v-btn
                    id="strDraw_btn"
                    class="elevation-0 rounded-0"
                    :color="drawon ? '#95BADF' : 'primary'"
                    x-small
                    dark
                    @click="startDraw()"
                    >START DRAW</v-btn
                  >
                  <v-btn
                    class="elevation-0 rounded-0 ml-1"
                    color="primary"
                    x-small
                    dark
                    @click="clearMeasure()"
                    >CLEAR</v-btn
                  >
                  <v-btn
                    dark
                    class="elevation-0 rounded-0 ml-1"
                    color="primary"
                    x-small
                    @click="onCount()"
                    >COUNT</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    class="elevation-0 rounded-0"
                    fab
                    x-small
                    color="#f7f7f7"
                    @click="
                      (etaControl = false),
                        (drawon = false),
                        clearMeasure(),
                        (totalDistance = 0),
                        (ex25 = false),
                        closeETA(),
                        (showRoute = false)
                    "
                  >
                    <v-icon dark> mdi-close </v-icon>
                  </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-toolbar
                  class="elevation-0 pa-0"
                  dense
                  color="#ffff"
                  style="display: flex"
                >
                  <div style="margin-left: -1.5em; display: flex">
                    <v-checkbox
                      v-model="ex25"
                      label=""
                      class="mx-0"
                      color="primary"
                      hide-details
                    ></v-checkbox>
                    <div
                      style="
                        font-size: 1em;
                        margin-left: -2em;
                        margin-top: 1.3em;
                      "
                    >
                      Start From Marker
                    </div>
                    <v-spacer style="width: 1em"></v-spacer>
                    <v-checkbox
                      v-model="showRoute"
                      label=""
                      color="primary"
                      value="red darken-3"
                      hide-details
                    ></v-checkbox>
                    <div
                      style="
                        font-size: 1em;
                        margin-left: -2em;
                        margin-top: 1.3em;
                      "
                    >
                      Show Route Detail
                    </div>
                  </div>
                </v-toolbar>
                <v-divider></v-divider>
                <div style="padding: 0em">
                  <v-list style="margin: auto">
                    <v-list-item>
                      <v-list-item-content style="text-align: left">
                        <table>
                          <tr>
                            <td>
                             Total Distance
                            </td>
                            <td>:</td>
                            <td>
                             
                                {{ etaMiles }}&nbsp;Nmi
                             
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Duration
                            </td>
                            <td>:</td>
                            <td>
                             
                                {{ etaDuration }}&nbsp;Hours
                             
                            </td>
                          </tr>
                          <tr>
                            <td>Speed</h3></td>
                            <td>:</h3></td>
                            <td>
                              
                                <input
                                  style="
                                    width: 7em;
                                    background-color: #d5e6f7;
                                    padding: 0.2em;
                                    margin-right: 0.1em;
                                    cursor: pointer;
                                  "
                                  v-model="etaSpeed"
                                  type="number"
                                  v-on:input="countETA()"
                                />&nbsp;Knots
                              
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Depature
                            </td>
                            <td>:</td>
                            <td>
                              
                                <input
                                  style="
                                    width: 7em;
                                    background-color: #d5e6f7;
                                    padding: 0.2em;
                                    margin-right: 0.1em;
                                    cursor: pointer;
                                  "
                                  type="datetime-local"
                                  id="departure-sailink"
                                  name="departure-form"
                                  v-on:input="countETA()"
                                />
                                <span id="depart-container"></span>&nbsp;WIB
                              
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Arrival
                            </td>
                            <td>:</td>
                            <td>
                              
                                <input
                                  style="
                                    width: 7em;
                                    background-color: #f7f7f7;
                                    padding: 0.2em;
                                    margin-right: 0.1em;
                                    cursor: auto;
                                  "
                                  type="text"
                                  readonly
                                  :value="etaArrival"
                                />&nbsp;WIB
                              
                            </td>
                          </tr>
                        </table>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>

                <span class="d-none" id="depart-input-container"></span>
              </v-card>
            </l-control>

          </l-map>
          <v-divider></v-divider>
          <v-toolbar dense color="#F7F7F7" elevation="0">
            User Who Can See This Vessel
            <v-spacer style="width: 20%"></v-spacer>
            <v-text-field
              style="border: solid 1px #e0e0e0"
              width="40"
              v-model="searchUserWho"
              hide-details
              prepend-inner-icon="mdi-magnify"
              placeholder="Search"
              solo
              clearable
              class="elevation-0 rounded-0"
            ></v-text-field>
          </v-toolbar>
          <v-divider></v-divider>
          <v-data-table
            :headers="headersUser"
            :items="vesselUsers"
            :items-per-page="itemsPerPageUser"
            class="elevation-0 rounded-0 dataTable userTable_desktop "
            hide-default-footer
            hide-default-header
            :search="searchUserWho"
            :page.sync="pageUser"
            @page-count="pageCountUser = $event"
            @pagination="intoFilterUser"
            dense
          >
            <template v-slot:header>
              <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">#</th>
              <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">Name</th>
              <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">Email</th>
              <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">Role</th>
              <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">Last Login</th>
            </template>
            <template v-slot:item="row">
              <tr>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.index + 1 }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.name }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.email }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.role_name }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.lastLogin }}
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-data-table
            :headers="headersUser"
            :items="vesselUsers"
            :items-per-page="3"
            class="elevation-0 rounded-0 userTable_mobile dataTable_Sailink"
            hide-default-footer
            hide-default-header
            :search="searchUserWho"
            :page.sync="pageUser"
            @page-count="pageCountUser = $event"
            @pagination="intoFilterUser"
            dense
            ><template v-slot:item="row">
              <tr>
                <td style="border-bottom: none; text-align: center">
                  <v-card
                    style="border-bottom: solid 1px #e0e0e0"
                    class="elevation-0 rounded-0 ma-0"
                    width="80vw"
                  >
                    <table>
                      <tr>
                        <td>{{ row.item.index + 1 }}</td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Name</td>
                        <td>:</td>
                        <td>{{ row.item.name }}</td>
                      </tr>
                      <tr>
                        <td>Email</td>
                        <td>:</td>
                        <td>{{ row.item.email }}</td>
                      </tr>
                      <tr>
                        <td>Role</td>
                        <td>:</td>
                        <td>{{ row.item.role_name }}</td>
                      </tr>
                      <tr>
                        <td>Last Login</td>
                        <td>:</td>
                        <td>{{ row.item.lastLogin }}</td>
                      </tr>
                    </table>
                  </v-card>
                </td>
              </tr>
            </template></v-data-table
          >
          <v-divider></v-divider>
          <v-toolbar dense class="elevation-0 rounded-0" color="#F7F7F7">
            <p class="mt-3" style="font-size: 0.8em">
              Showing {{ showingDatafromUser }} to {{ showingDatatoUser }} of
              {{ totalFilterUser }} entries
            </p>
            <v-spacer></v-spacer>
            <v-pagination
              color="primary"
              v-if="showmaptable"
              v-model="pageUser"
              :length="pageCountUser"
              :total-visible="7"
            ></v-pagination>
          </v-toolbar>
        </v-card>
      </v-card>

      <v-card
        style="border: solid 1px #e0e0e0"
        class="ma-3 datatabledetail rounded-0 mt-0 mb-0"
        elevation="0"
      >
        <v-toolbar
          v-if="showmaptable"
          elevation="0"
          style="max-height: 70px"
          color="#F7F7F7"
          fixed
          dense
        >
          <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                style="border: solid 1px #e0e0e0"
                small
                class="rounded-0 pa-1 elevation-0 ma-0 mr-2"
                color="#ffff"
                v-bind="attrs"
                v-on="on"
              >
                {{ kFormatter(itemsPerPage)
                }}<v-icon small style="margin-left: 0.2em"
                  >mdi-unfold-more-horizontal</v-icon
                >
              </v-btn>
            </template>
            <v-list style="border: solid 1px #e0e0e0">
              <v-list-item @click="itemsPerPage = 10"
                ><v-list-item-title>10</v-list-item-title></v-list-item
              >
              <v-list-item @click="itemsPerPage = 25"
                ><v-list-item-title>25</v-list-item-title></v-list-item
              >
              <v-list-item @click="itemsPerPage = 50"
                ><v-list-item-title>50</v-list-item-title></v-list-item
              >
              <v-list-item @click="itemsPerPage = 100"
                ><v-list-item-title>100</v-list-item-title></v-list-item
              >
            </v-list>
          </v-menu>
          <v-btn
            color="primary"
            class="elevation-0 rounded-0 csvsailink_desktop"
            @click="createCSV()"
            small
            ><v-icon small>mdi-file-move</v-icon> &nbsp;Export CSV</v-btn
          >
          <v-btn
            color="primary"
            class="elevation-0 rounded-0 ml-3 pdfsailink_desktop"
            @click="createPDF()"
            small
            ><v-icon small>mdi-file-move</v-icon> &nbsp;Export PDF</v-btn
          >
          <v-btn
            color="primary"
            class="elevation-0 rounded-0 csvsailink_mobile"
            @click="createCSV()"
            x-small
            >CSV</v-btn
          >
          <v-btn
            color="primary"
            class="elevation-0 rounded-0 ml-3 pdfsailink_mobile"
            @click="createPDF()"
            x-small
            >PDF</v-btn
          >

          <v-spacer style="width: 50%"></v-spacer>
          <v-text-field
            style="border: solid 1px #e0e0e0"
            width="40"
            v-model="search"
            hide-details
            prepend-inner-icon="mdi-magnify"
            placeholder="Search"
            solo
            clearable
            class="elevation-0 rounded-0"
          ></v-text-field>
        </v-toolbar>
        <v-divider></v-divider>
        <v-layout v-resize="onResize" column style="">
          <v-container
            id="map_sailink"
            v-if="!showmaptracking"
            fill-height
            fluid
            style="height: 250px"
            class="elevation-0"
          >
            <v-row align="center" justify="center">
              <v-col
                ><img
                  alt="Navplus logo"
                  width="70px"
                  :src="loadernavplus"
                  class="justify-center"
              /></v-col>
            </v-row>
          </v-container>
          <v-data-table
            :search="search"
            style="margin-top: 0px"
            v-if="showmaptracking && showmaptable.weather == null"
            :headers="headersData"
            :items="tableTracking"
            hide-default-footer
            hide-default-header
            :page.sync="page"
            :items-per-page="itemsPerPage"
            class="elevation-0 dataTable trackingTable_sailinkdesktop"
            @page-count="pageCount = $event"
            @pagination="intoFilter"
          >
            <template v-slot:header>
              <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">No</th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">
                Latitude, Longitude<br />(DMS)
              </th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">
                Heading<br />(Degree)
              </th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">
                Speed<br />(Knots)
              </th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">
                Distance<br />(Nmi)
              </th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">RX SNR<br />(db)</th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">RX<br />MODCOD</th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">
                TX Power<br />(db)
              </th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">SatNet</th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">
                Date/Time<br />(GMT+7)
              </th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">Link Status</th>
            </template>
            <template v-slot:item="row">
              <tr>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.index + 1 }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  <a @click="triggerPopup(row.item)"
                    >{{ row.item.lat }} , {{ row.item.lng }}<br />({{
                      row.item.dms
                    }})</a
                  >
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.heading }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.speed }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.distance }}
                </td>
                <td
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.rx_snr }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.modcod }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.tx }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.satnet }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ row.item.dateTime }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  <v-chip
                    style="width: 60px"
                    v-if="row.item.isActive"
                    class="elevation-0"
                    color="#38C072"
                    text-color="white"
                    small
                  >
                    &nbsp;&nbsp;&nbsp;UP
                  </v-chip>

                  <v-chip
                    style="width: 60px"
                    v-if="!row.item.isActive"
                    class="elevation-0"
                    color="red"
                    text-color="white"
                    small
                  >
                    DOWN
                  </v-chip>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-data-table
            :search="search"
            style="margin-top: 0px"
            v-if="showmaptracking && showmaptable.weather != null"
            :headers="headers"
            :items="tableTracking"
            multi-sort
            hide-default-footer
            hide-default-header
            :page.sync="page"
            :items-per-page="itemsPerPage"
            class="elevation-0 dataTable trackingTable_sailinkdesktop"
            @page-count="pageCount = $event"
            item-key="msg_id"
            :expanded.sync="expanded"
            @pagination="intoFilter"
            :single-expand="singleExpand"
          >
            <template v-slot:header>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2"></th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">No</th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">
                Latitude, Longitude<br />(DMS)
              </th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">
                Heading<br />(Degree)
              </th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">
                Speed<br />(Knots)
              </th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">
                Distance<br />(Nmi)
              </th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">RX SNR<br />(db)</th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">RX<br />MODCOD</th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">
                TX Power<br />(db)
              </th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">SatNet</th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">
                Date/Time<br />(GMT+7)
              </th>
              <th class="tableHeader_ pa-0 pt-2 pl-1 pb-2">Link Status</th>
            </template>
            <template v-slot:item="{ item, expand, isExpanded }">
              <tr>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  <v-btn
                    x-small
                    class="mx-2 rounded-0 elevation-0"
                    fab
                    dark
                    color="primary"
                    @click="
                      !isExpanded
                        ? (weatherClick(
                            showmaptable.id,
                            item.msg_id,
                            'sailink',
                            item.dateTime
                          ),
                          expand(!isExpanded))
                        : (removeWeather(item.dateTime), expand(!isExpanded))
                    "
                  >
                    <v-icon dark>
                      {{ !isExpanded ? "mdi-plus" : "mdi-minus" }}
                    </v-icon>
                  </v-btn>
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.index + 1 }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  <a @click="triggerPopup(item)"
                    >{{ item.lat }} , {{ item.lng }}<br />({{ item.dms }})</a
                  >
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.heading }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.speed }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.distance }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.rx_snr }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.modcod }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.tx }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.satnet }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  {{ item.dateTime }}
                </td>
                <td
                  class="pa-0"
                  style="white-space: nowrap; padding: 1em; text-align: center"
                >
                  <v-chip
                    style="width: 60px"
                    v-if="item.isActive"
                    class="elevation-0"
                    color="#38C072"
                    text-color="white"
                    small
                  >
                    &nbsp;&nbsp;&nbsp;UP
                  </v-chip>

                  <v-chip
                    style="width: 60px"
                    v-if="!item.isActive"
                    class="elevation-0"
                    color="red"
                    text-color="white"
                    small
                  >
                    DOWN
                  </v-chip>
                </td>
              </tr>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" style="background-color: #c1c1c1">
                <v-toolbar
                  class="elevation-0 text-center"
                  dense
                  color="#F7F7F7"
                  elevation="2"
                >
                  <v-spacer> Weather & Wave </v-spacer></v-toolbar
                >
                <v-progress-linear
                  v-if="!weatherData[item.dateTime]"
                  indeterminate
                  color="primary"
                  height="7"
                  striped
                ></v-progress-linear>
                <v-row
                  v-if="weatherData[item.dateTime]"
                  no-gutters
                  style="flex-wrap: nowrap"
                >
                  <v-col
                    cols="1"
                    style="min-width: 100px; max-width: 100%; margin: 5px"
                    class="flex-grow-1 flex-shrink-0"
                  >
                    <v-card class="pa-2" outlined tile>
                      <v-card-text>
                        <v-simple-table>
                          <template v-slot:default>
                            <tr>
                              <td style="padding: 6px">Weather</td>
                              <td style="padding: 6px">
                                {{ weatherData[item.dateTime].weather }}
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 6px">Wind Direction</td>
                              <td style="padding: 6px">
                                {{ weatherData[item.dateTime].windDirection }}
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 6px">Wind Speed</td>
                              <td style="padding: 6px">
                                {{ weatherData[item.dateTime].windSpeed }}
                              </td>
                            </tr>
                          </template>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="1"
                    style="min-width: 100px; max-width: 100%; margin: 5px"
                    class="flex-grow-1 flex-shrink-0"
                  >
                    <v-card class="pa-2" outlined tile>
                      <v-card-text>
                        <v-simple-table>
                          <template v-slot:default>
                            <tr>
                              <td style="padding: 6px">Temperature</td>
                              <td style="padding: 6px">
                                {{ weatherData[item.dateTime].temperature }}
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 6px">Humidity</td>
                              <td style="padding: 6px">
                                {{ weatherData[item.dateTime].humidity }}
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 6px">Dew Point</td>
                              <td style="padding: 6px">
                                {{ weatherData[item.dateTime].dewPoint }}
                              </td>
                            </tr>
                          </template>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="1"
                    style="min-width: 100px; max-width: 100%; margin: 5px"
                    class="flex-grow-1 flex-shrink-0"
                  >
                    <v-card class="pa-2" outlined tile>
                      <v-card-text>
                        <v-simple-table>
                          <template v-slot:default>
                            <tr>
                              <td style="padding: 6px">Wave Height</td>
                              <td style="padding: 6px">
                                {{
                                  weatherData[item.dateTime]
                                    .waveSignificantHeight
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 6px">Wave From Direction</td>
                              <td style="padding: 6px">
                                {{
                                  weatherData[item.dateTime].waveFromDirection
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 6px">
                                <p style="height: 2px"></p>
                              </td>
                              <td style="padding: 6px">
                                <p style="height: 2px"></p>
                              </td>
                            </tr>
                          </template>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </td>
            </template>
          </v-data-table>
          <v-data-table
            :search="search"
            style="margin-top: 0px"
            v-if="showmaptracking && showmaptable.weather != null"
            :headers="headers"
            :items="tableTracking"
            multi-sort
            hide-default-footer
            hide-default-header
            :page.sync="page"
            :items-per-page="itemsPerPage"
            class="elevation-0 dataTable_Sailink trackingTable_sailinkmobile"
            @page-count="pageCount = $event"
            item-key="msg_id"
            :expanded.sync="expanded"
            @pagination="intoFilter"
            :single-expand="singleExpand"
            ><template v-slot:item="row">
              <tr>
                <td style="border-bottom: none; text-align: center">
                  <v-card
                    style="border: solid 1px #e0e0e0"
                    class="elevation-0 rounded-0 ma-1"
                    width="80vw"
                  >
                    <v-toolbar
                      style="border-bottom: solid 1px #e0e0e0"
                      class="elevation-0 rounded-0"
                      dense
                      >{{ row.item.index + 1 }}<v-spacer></v-spacer>
                      <v-btn
                      
                        @click="!weatherData[row.item.dateTime] ? weatherClick(
                            showmaptable.id,
                            row.item.msg_id,
                            'sailink',
                            row.item.dateTime
                          ) : removeWeather(row.item.dateTime)"
                        x-small
                        class="mx-2 rounded-0 elevation-0"
                        fab
                        dark
                        color="primary"
                      >
                        <v-icon dark>
                          {{ !weatherData[row.item.dateTime] ? "mdi-plus" : "mdi-minus" }}
                        </v-icon>
                      </v-btn></v-toolbar
                    >
                    <v-card-text>
                      <table>
                        <tr>
                          <td>Latitude, Longitude (DMS)</td>
                          <td>:</td>
                          <td>
                            <a @click="triggerPopup_mobile(row.item)"
                              >{{ row.item.lat }}, {{ row.item.lng }} ({{
                                row.item.dms
                              }})</a
                            >
                          </td>
                        </tr>
                        <tr>
                          <td>Heading (Degree)</td>
                          <td>:</td>
                          <td>{{ row.item.heading }}</td>
                        </tr>
                        <tr>
                          <td>Speed (Knots)</td>
                          <td>:</td>
                          <td>{{ row.item.speed }}</td>
                        </tr>
                        <tr>
                          <td>Distance (Nmi)</td>
                          <td>:</td>
                          <td>{{ row.item.distance }}</td>
                        </tr>
                        <tr>
                          <td>RX SNR (db)</td>
                          <td>:</td>
                          <td>{{ row.item.rx_snr }}</td>
                        </tr>
                        <tr>
                          <td>RX MODCOD</td>
                          <td>:</td>
                          <td>{{ row.item.modcod }}</td>
                        </tr>
                        <tr>
                          <td>TX Power (db)</td>
                          <td>:</td>
                          <td>{{ row.item.tx }}</td>
                        </tr>
                        <tr>
                          <td>SatNet</td>
                          <td>:</td>
                          <td>{{ row.item.satnet }}</td>
                        </tr>
                        <tr>
                          <td>Date/Time (GMT+7)</td>
                          <td>:</td>
                          <td>{{ row.item.dateTime }}</td>
                        </tr>
                        <tr>
                          <td>Link Status</td>
                          <td>:</td>
                          <td>
                            <v-chip
                              style="width: 60px"
                              v-if="row.item.isActive"
                              class="elevation-0"
                              color="#38C072"
                              text-color="white"
                              small
                            >
                              &nbsp;&nbsp;&nbsp;UP
                            </v-chip>

                            <v-chip
                              style="width: 60px"
                              v-if="!row.item.isActive"
                              class="elevation-0"
                              color="red"
                              text-color="white"
                              small
                            >
                              DOWN
                            </v-chip>
                          </td>
                        </tr>
                      </table>
                    </v-card-text>
                  </v-card>
                </td>
              
              </tr>
           
                  <v-progress-linear
                  v-if="showclick_dateTime[row.item.dateTime] == row.item.dateTime && !weatherData[row.item.dateTime]"
                  indeterminate
                  color="primary"
                  height="7"
                  striped
                ></v-progress-linear>
                
              </tr>
              <tr style="background-color:#C1C1C1" v-if="weatherData[row.item.dateTime]">
                <td style="border-bottom: none; text-align: center">
                  <v-card
                    style="border: solid 1px #e0e0e0"
                    class="elevation-0 rounded-0 ma-1"
                    width="80vw"
                  >
                    <v-toolbar
                      style="border-bottom: solid 1px #e0e0e0"
                      class="elevation-0 rounded-0"
                      dense
                      >Weather & Wave<v-spacer></v-spacer>
                     </v-toolbar
                    >
                    <v-card-text>
                      <table>
                        <tr>
                          <td>Weather</td>
                          <td>:</td>
                          <td>
                            {{ weatherData[row.item.dateTime].weather }}
                          </td>
                        </tr>
                        <tr>
                          <td>Wind Direction</td>
                          <td>:</td>
                          <td> {{ weatherData[row.item.dateTime].windDirection }}</td>
                        </tr>
                        <tr>
                          <td>Wind Speed</td>
                          <td>:</td>
                          <td> {{ weatherData[row.item.dateTime].weather }}</td>
                        </tr>
                        <tr>
                          <td>Temperature</td>
                          <td>:</td>
                          <td>{{ weatherData[row.item.dateTime].temperature }}</td>
                        </tr>
                        <tr>
                          <td>Humidity</td>
                          <td>:</td>
                          <td>{{ weatherData[row.item.dateTime].humidity }}</td>
                        </tr>
                        <tr>
                          <td>Humidity</td>
                          <td>:</td>
                          <td> {{ weatherData[row.item.dateTime].dewPoint }}</td>
                        </tr>
                       
                        <tr>
                          <td>Wave Height</td>
                          <td>:</td>
                          <td>{{  weatherData[row.item.dateTime]
                                    .waveSignificantHeight}}</td>
                        </tr>
                        <tr>
                          <td>Wave From Direction</td>
                          <td>:</td>
                          <td>  {{
                                  weatherData[row.item.dateTime].waveFromDirection
                                }}</td>
                        </tr>
                      </table>
                    </v-card-text>
                  </v-card>
                </td>
              </tr>
            </template></v-data-table
          >
          <v-data-table
            :search="search"
            style="margin-top: 0px"
            v-if="showmaptracking && showmaptable.weather == null"
            :headers="headers"
            :items="tableTracking"
            multi-sort
            hide-default-footer
            hide-default-header
            :page.sync="page"
            :items-per-page="itemsPerPage"
            class="elevation-0 dataTable_Sailink trackingTable_sailinkmobile"
            @page-count="pageCount = $event"
            item-key="msg_id"
            @pagination="intoFilter"
            ><template v-slot:item="row">
              <tr>
                <td style="border-bottom: none; text-align: center">
                  <v-card
                    style="border: solid 1px #e0e0e0"
                    class="elevation-0 rounded-0 ma-1"
                    width="80vw"
                  >
                    <v-toolbar
                      style="border-bottom: solid 1px #e0e0e0"
                      class="elevation-0 rounded-0"
                      dense
                      >{{ row.item.index + 1 }}<v-spacer></v-spacer>
                      </v-toolbar
                    >
                    <v-card-text>
                      <table>
                        <tr>
                          <td>Latitude, Longitude (DMS)</td>
                          <td>:</td>
                          <td>
                            <a @click="triggerPopup_mobile(row.item)"
                              >{{ row.item.lat }}, {{ row.item.lng }} ({{
                                row.item.dms
                              }})</a
                            >
                          </td>
                        </tr>
                        <tr>
                          <td>Heading (Degree)</td>
                          <td>:</td>
                          <td>{{ row.item.heading }}</td>
                        </tr>
                        <tr>
                          <td>Speed (Knots)</td>
                          <td>:</td>
                          <td>{{ row.item.speed }}</td>
                        </tr>
                        <tr>
                          <td>Distance (Nmi)</td>
                          <td>:</td>
                          <td>{{ row.item.distance }}</td>
                        </tr>
                        <tr>
                          <td>RX SNR (db)</td>
                          <td>:</td>
                          <td>{{ row.item.rx_snr }}</td>
                        </tr>
                        <tr>
                          <td>RX MODCOD</td>
                          <td>:</td>
                          <td>{{ row.item.modcod }}</td>
                        </tr>
                        <tr>
                          <td>TX Power (db)</td>
                          <td>:</td>
                          <td>{{ row.item.tx }}</td>
                        </tr>
                        <tr>
                          <td>SatNet</td>
                          <td>:</td>
                          <td>{{ row.item.satnet }}</td>
                        </tr>
                        <tr>
                          <td>Date/Time (GMT+7)</td>
                          <td>:</td>
                          <td>{{ row.item.dateTime }}</td>
                        </tr>
                        <tr>
                          <td>Link Status</td>
                          <td>:</td>
                          <td>
                            <v-chip
                              style="width: 60px"
                              v-if="row.item.isActive"
                              class="elevation-0"
                              color="#38C072"
                              text-color="white"
                              small
                            >
                              &nbsp;&nbsp;&nbsp;UP
                            </v-chip>

                            <v-chip
                              style="width: 60px"
                              v-if="!row.item.isActive"
                              class="elevation-0"
                              color="red"
                              text-color="white"
                              small
                            >
                              DOWN
                            </v-chip>
                          </td>
                        </tr>
                      </table>
                    </v-card-text>
                  </v-card>
                </td>
              </tr>
            </template></v-data-table
          >
          <v-divider></v-divider>
          <v-toolbar dense class="elevation-0 rounded-0" color="#F7F7F7">
            <p class="mt-3" style="font-size: 0.8em">
              Showing {{ showingDatafrom }} to {{ showingDatato }} of
              {{ totalFilter }} entries
            </p>
            <v-spacer></v-spacer>
            <v-pagination
              color="primary"
              v-if="showmaptable"
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-toolbar>
        </v-layout>

        <div id="app">
          <v-app id="inspire"> </v-app>
        </div>
      </v-card>

      <!--Modal Image-->
      <!--Modal Image-->
      <v-dialog v-model="imageOpen">
        <v-carousel hide-controls hide-delimiters>
          <v-carousel-item
            @click="imageOpen = false"
            v-for="(item, i) in showmaptable.images"
            :key="i"
          >
            <img style="height: 100%" :src="item[0]" />
          </v-carousel-item>
        </v-carousel>
      </v-dialog>
      <!--Modal Image End-->
      <!--Modal Notif End-->
    </v-card>

    <!--Modal App-->
    <v-dialog v-model="qdaily" width="85vw" persistent>
      <v-card color="#fff" class="elevation-0 rounded-0">
        <v-toolbar color="#f7f7f7" class="elevation-0 rounded-0" dense>
         Quota daily usage {{ serviceQuota }}
              

          <v-spacer></v-spacer>

          <v-btn
            class="elevation-0 rounded-0"
            small
            icon
            @click="(qdaily = false), removeQuota()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-toolbar v-if="showmaptable" dense class="elevation-0 rounded-0">
        
         
            {{showmaptable.vessel_pt}}
         
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-divider v-if="showmaptable"></v-divider>
        <v-container v-if="!quotaData" fill-height fluid>
          <v-row align="center" justify="center">
            <v-col
              ><img
                alt="Navplus logo"
                width="70px"
                :src="loadernavplus"
                class="justify-center"
            /></v-col>
          </v-row>
        </v-container>

        <v-card-text v-if="quotaData" style="padding: 2em">
          <QuotaChart
            v-if="serviceQuota == 'metered'"
            v-bind:dataChart="quotaData.chart"
          />

          <QuotaChartLine v-else v-bind:dataChart="quotaData.chart" />
        </v-card-text>

        <v-card-actions class="justify-end"> </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Modal App End-->

    <!--Modal Custom Range-->
    <v-dialog
      ref="dialog"
      v-model="dateopen"
      :return-value.sync="dates"
      class="elevation-0 rounded-0"
      persistent
      width="290px"
    >
      <v-date-picker
        color="primary"
        class="elevation-0 rounded-0"
        v-model="dates"
        range
        scrollable
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="dateopen = false"> Cancel </v-btn>
        <v-btn text color="primary" @click="customRange()"> OK </v-btn>
      </v-date-picker>
    </v-dialog>
    <!--Modal Custom Range-->
  </v-card>
</template>

<script>
import axios from "axios";
import { mapSettingsShow } from "@/constants/mapSettings";
import mapstyle from "@/assets/json/mapstyle.json";
import { mapActions, mapGetters } from "vuex";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import datepickerFactory from "jquery-datepicker";
import QuotaChart from "@/components/charts/QuotaChart.vue";
import QuotaChartLine from "@/components/charts/QuotaChartLine.vue";
import L from "leaflet";
import {
  LPopup,
  LMap,
  LTileLayer,
  LIcon,
  LControl,
  LPolygon,
  // LPolyline,
  // LCircle,
  LControlZoom,
} from "vue2-leaflet";
// import LMovingMarker from 'vue2-leaflet-movingmarker'
import Vue2LeafletRotatedMarker from "vue2-leaflet-rotatedmarker";
import LControlFullscreen from "vue2-leaflet-fullscreen";
import LControlPolylineMeasure from "vue2-leaflet-polyline-measure";
import LMovingRotatedMarker from 'vue2-leaflet-rotatedmarker'
import {
  cns11,
  cns11gain, //data gain onclkick
  cns11_gnt, // skyreach1 gnt
  cns11_gntgain, //skyreach 1 gnt gain info
} from "@/assets/js/cns11.js";
import {
  apstar5,
  apstar5gain,
  apstar5_gnt,
  apstar5_gntgain,
} from "@/assets/js/apstar5.js";
import {
  apstar92,
  apstar92gain,
  apstar92_gnt,
  apstar92_gntgain,
} from "@/assets/js/apstar9.js";
import $ from "jquery";
import { abs, absgain, abs_gnt, abs_gntgain } from "@/assets/js/abs.js";
import { ocn, ocngain, ocn_gnt, ocn_gntgain } from "@/assets/js/oceanbeam.js";
import { ReInviteUserAgentServer } from 'sip.js/lib/core';



const iconUrl= 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDIuODggMy40NiI+PGRlZnM+PHN0eWxlPi5ke2ZpbGw6IzAwMDBGRjtzdHJva2U6I2ZmZjtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6LjJweDt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9ImEiLz48ZyBpZD0iYiI+PGcgaWQ9ImMiPjxwYXRoIGNsYXNzPSJkIiBkPSJNMi42OSwzLjI2bC0uOTYtLjQ1Yy0uMTktLjA5LS40LS4wOS0uNTksMGwtLjk2LC40NUwxLjQ0LC4yNmwxLjI1LDNaIi8+PC9nPjwvZz48L3N2Zz4='


export default {
  components: {
    // GMapMarkerShowMap,
    // GoogleMapLine,
    // GoogleMapCircle,
    // InfoWindowPoly,
    // GMapSailink,
    LPopup,
    LIcon,
    LMap,
    LTileLayer,
    LControl,
    LPolygon,
    // LPolyline,
    // LCircle,
    QuotaChart,
    QuotaChartLine,
    LControlZoom,
    // LMovingMarker,
    LControlPolylineMeasure,
    LControlFullscreen,
    "v-rotated-marker": Vue2LeafletRotatedMarker,
    LMovingRotatedMarker
  },







  data() {
    return {
      IntervalMoving: null,
      fetchInterval:null,
      icon: L.icon({
                    iconUrl: iconUrl,
                    iconSize: [15,20],
                    iconAnchor: [7.5,10],
                    popupAnchor: [0,-25]
                }),
                 drivePath : null,
                 driveLatLng: null,
                 driveRotationAngle: null,
                driveMarker:null,
      showclick_dateTime: [],
      map_sailink_fs: false,
      totalFilter: null,
      totalFilterUser: null,
      itemsPerPageUser: 5,
      ex25: false,
      searchUserWho: "",
      qdaily: null,
      weatherData: [],
      imageOpenData: null,
      showRoute: false,
      showRouteData: null,
      showRouteEmpty: [{ index: 0, lat: "-", lng: "-", br: "-" }],
      brRouteData: null,
      headersRoute: [
        {
          text: "#",
          value: "index",
        },
        { text: "Latitude/Longitude", value: "Latitude" },
        { text: "Distance/Bearing", value: "Distance/Bearing" },
      ],
      drawon: null,
      etaControl: false,
      url: "https://maps.skyreach.id/sailink/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      datepickerID: null,
      dates: [],
      menu: false,
      a: 0,
      measurepoly: 0,
      mobileBreakpoint: 600,
      singleExpand: false,
      expanded: [],
      dateopen: false,
      itemsPerPage: 10,
      itemsPerPageCoordinate: 10,
      page: 1,
      pageCount: 0,
      pageUser: 1,
      pageCountUser: 0,
      pageImage: 1,
      pageCountImage: 0,
      pageCoordinate: 1,
      pageCountCoordinate: 0,
      search: "",
      countLength:0,
      markers: [
        {
          id: "a",
          position: { lat: 3, lng: 101 },
        },
        {
          id: "b",
          position: { lat: 5, lng: 99 },
        },
        {
          id: "c",
          position: { lat: 6, lng: 97 },
        },
      ],
      lines: [
        {
          id: "1",
          path: [
            { lat: 3, lng: 101 },
            { lat: 5, lng: 99 },
          ],
        },
        {
          id: "2",
          path: [
            { lat: 5, lng: 99 },
            { lat: 6, lng: 97 },
          ],
        },
      ],

      path: [
        { lat: -1.67292, lng: 100.63035 },
        { lat: -4.01517, lng: 102.28569 },
      ],

      loadernavplus: require("@/assets/img/load100new.gif"),
      headersData: [
        {
          text: "No",
          align: "start",
          sortable: false,
        },
        { text: "Latitude, Longtitude (DMS)", value: "lat", sortable: false },
        { text: "Heading (Degree)", value: "heading", sortable: false },
        { text: "Speed (Knots)", value: "speed", sortable: false },
        { text: "Distance(Nmi)", value: "distance", sortable: false },
        { text: "RX SNR (db)", value: "rx_snr", sortable: false },
        { text: "RX MODCOD", value: "modcod", sortable: false },
        { text: "TX Power(db)", value: "tx", sortable: false },
        { text: "SatNet", value: "satnet", sortable: false },
        { text: "Date/Time (GMT+7)", value: "dateTime", sortable: false },
        { text: "Link Status", value: "good", sortable: false },
      ],
      headers: [
        {
          text: "",
          align: "start",
          sortable: false,
        },
        {
          text: "No",
          align: "start",
          sortable: false,
        },
        { text: "Latitude, Longtitude (DMS)", value: "lat", sortable: false },
        { text: "Heading (Degree)", value: "heading", sortable: false },
        { text: "Speed (Knots)", value: "speed", sortable: false },
        { text: "Distance(Nmi)", value: "distance", sortable: false },
        { text: "RX SNR (db)", value: "rx_snr", sortable: false },
        { text: "RX MODCOD", value: "modcod", sortable: false },
        { text: "TX Power(db)", value: "tx", sortable: false },
        { text: "SatNet", value: "satnet", sortable: false },
        { text: "Date/Time (GMT+7)", value: "dateTime", sortable: false },
        { text: "Link Status", value: "good", sortable: false },
      ],

      headersUser: [
        {
          text: "#",
          align: "start",
          sortable: false,
        },
        { text: "Name", value: "name", sortable: false },
        { text: "Email", value: "email", sortable: false },
        { text: "Role", value: "role_name", sortable: false },
        { text: "Last Login", value: "lastLogin", sortable: false },
      ],

      options: {
        disableDefaultUI: true,
        fullscreenControl: true,
        zoomControl: true,
        styles: mapstyle,
      },
      model: 0,
      etaArrival: "",
      etaDuration: 0,
      etaSpeed: 1,
      etaMiles: 0,
      unit: "nauticalmiles",
      satellite: require("@/assets/img/satellite.png"),
      imageOpen: null,
      totalDistance: null,
      imageData: null,
      msg_id_after: null,
      paths_cns11: cns11,
      gain_cns11: cns11gain,
      paths_cns11gnt: cns11_gnt,
      gain_cns11gnt: cns11_gntgain,
      paths_apstar5: apstar5,
      gain_apstar5: apstar5gain,
      paths_apstar5gnt: apstar5_gnt,
      gain_apstar5gnt: apstar5_gntgain,
      paths_apstar9: apstar92,
      gain_apstar9: apstar92gain,
      paths_apstar9gnt: apstar92_gnt,
      gain_apstar9gnt: apstar92_gntgain,
      paths_abs: abs,
      gain_abs: absgain,
      paths_absgnt: abs_gnt,
      gain_absgnt: abs_gntgain,
      paths_ocn: ocn,
      gain_ocn: ocngain,
      paths_ocngnt: ocn_gnt,
      gain_ocngnt: ocn_gntgain,
      EIRP: null,
      GNT: null,
      SKYR1: null,
      SKYR2: null,
      APST9: null,
      ABS2A: null,
      SR1MR: null,
      user_allowed: JSON.parse(localStorage.getItem("user_data")),
      polygon: {
        skyr1: "green",
        skyr2: "blue",
        apst9: "purple",
        abs2a: "orange",
        sr1mr: "#F7038B",
      },
    };
  },

  

  mounted() {
    var userallow = localStorage.getItem("user_data");
    this.user_allowed = JSON.parse(userallow);

   this.initialdata_movingfirst()

    datepickerFactory($);

    $(function () {
      $("#datepicker").datepicker();
    });
    var mama = this;
    // if(this.searchVesselID){
    // //console.log('jalan')
    // //console.log(this.sailink_executed)
    if (!mama.sailink_executed) {
      //console.log("jalan title map");
      mama.addsailink_executed(true);
      $("html, body").animate(
        {
          scrollTop: $("#title_map_sailink").offset().top - 109,
        },
        800
      );
    } else {
      ////console.log("Muncul"), //console.log(mama.sailink_executed);
    }

    //   this.$nextTick(() => {

    // this.draw_Circle()

    //  })
  },

  methods: {
    ...mapActions([
      "removeQuota",
      "showondate",
      "lnStatus",
      "showweather",
      "removeShowMap",
      "fetchQuota",
      "addsailink_executed",
    ]),

    initialdata_movingfirst(){
      var mother = this
  
            mother.drivePath = mother.showmaptracking.tracking.slice()
    mother.driveLatLng= L.latLng([mother.drivePath[0].lat, mother.drivePath[0].lng])
    mother.driveRotationAngle= mother.drivePath[0].heading

 
    },

    initialdata_moving(){
      var mother = this
 
          if (mother.showmaptracking) {
    
            mother.drivePath = mother.showmaptracking.tracking.slice()
    mother.driveLatLng= L.latLng([mother.drivePath[0].lat, mother.drivePath[0].lng])
    mother.driveRotationAngle= mother.drivePath[0].heading
    clearInterval(mother.fetchInterval);
    return
          }
       

      
   

 
    },

    movingStart(){
      var mother=this
      this.IntervalMoving = setInterval(function () {
            mother.simulate()
          }, 100);
     
    },

    simulate() {  
      
                this.countLength=this.countLength+1
                console.log(this.countLength)
                console.log(this.drivePath)
                if(this.drivePath.length>0){
                if(!this.drivePath.length) {
                    this.$refs.driveMarker.mapObject.setLatLng(L.latLng([this.drivePath[0].lat, this.drivePath[0].lng]))
                    this.drivePath= this.drivePath.slice()
                    return
                }
                let point= this.drivePath.shift()
                this.driveLatLng= L.latLng([point.lat, point.lng])
                this.driveRotationAngle= point.heading
                console.log(this.driveRotationAngle)
                if(this.showmaptracking.tracking)
               {
                if(this.countLength == this.showmaptracking.tracking.length){
                  clearInterval(this.IntervalMoving);
                }
               }
              return
              }
            },

    triggerFullscreen() {
      if (this.$refs["map_sailink"].mapObject._isFullscreen != true) {
        this.$refs.map_sailink.mapObject.scrollWheelZoom.disable();
      } else {
        this.$refs.map_sailink.mapObject.scrollWheelZoom.enable();
      }
    },

    intoFilter(pagination) {
      this.totalFilter = pagination.itemsLength;
    },

    intoFilterUser(pagination) {
      this.totalFilterUser = pagination.itemsLength;
    },

    closeShowMap() {
      clearInterval(this.IntervalMoving);
      this.removeShowMap();
      $("html, body").animate(
        {
          scrollTop: $("#top_mysailink").offset().top - 140,
        },
        800
      );
    },

    kFormatter(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
    },

    closeETA() {
      if (this.$refs["map_sailink"].mapObject._isFullscreen != true) {
        //console.log("FULLSCREEN CLOSE");
      } else {
        this.$refs["map_sailink"].mapObject.toggleFullscreen();
      }
    },

    draw_Circle() {
      var myMap = this.$refs.map_sailink.mapObject;
      var latLong = this.showmaptracking.tracking;
      var pointList = this.showmaptracking.tracking;
      var mama = this;
      var firstpolyline = new L.Polyline(pointList, {
        color: "#FEE800",
        weight: 4,
        opacity: 1,
        smoothFactor: 1,
      });
      firstpolyline.addTo(myMap);
      // Here's where you iterate over the array of coordinate objects.
      latLong.forEach(function (coord) {
        if (
          coord.lat != mama.showmaptracking.maptop.lat &&
          coord.lng != mama.showmaptracking.maptop.lon
        ) {
          var circle = L.circle(coord, {
            color: "#1DC01D",
            fillColor: "#1DC01D",
            fillOpacity: 0.5,
            radius: 1800,
          })
            .addTo(myMap)
            .bindPopup(
              "<table><tr><td><b>Latitude</b></td><td>:</td><td>" +
                coord.lat +
                "</td></tr><tr><td><b>Longitude</b></td><td>:</td><td>" +
                coord.lng +
                "</td></tr><tr>" +
                "<td><b>DMS</b></td><td>:</td>" +
                "<td>" +
                coord.dms +
                "</td>" +
                "</tr>" +
                "<tr>" +
                "<td><b>Speed</b></td>" +
                "<td>:</td>" +
                " <td>" +
                coord.speed +
                "&nbsp;knots </td>" +
                "</tr>" +
                "<tr>" +
                " <td><b>Heading</b></td>" +
                "<td>:</td>" +
                "<td>" +
                coord.heading +
                "</td>" +
                " </tr>" +
                "<tr>" +
                "<td><b>Last Update</b></td>" +
                "<td>:</td>" +
                "<td>" +
                coord.updated +
                "</td>" +
                "</tr>" +
                "</table>"
            );
        }
      });
    },

    triggerPopup_mobile(coord) {
      //console.log(coord);
      $("html, body").animate(
        {
          scrollTop: $("#map_sailink_").offset().top - 109,
        },
        800
      );
      var myMap = this.$refs.map_sailink.mapObject;
      var popLocation = new L.LatLng(coord.lat, coord.lng);
      myMap.setView(popLocation, 6);
      var popup = L.popup()
        .setLatLng(popLocation)
        .setContent(
          "<table><tr><td><b>Latitude</b></td><td>:</td><td>" +
            coord.lat +
            "</td></tr><tr><td><b>Longitude</b></td><td>:</td><td>" +
            coord.lng +
            "</td></tr><tr>" +
            "<td><b>DMS</b></td><td>:</td>" +
            "<td>" +
            coord.dms +
            "</td>" +
            "</tr>" +
            "<tr>" +
            "<td><b>Speed</b></td>" +
            "<td>:</td>" +
            " <td>" +
            coord.speed +
            "&nbsp;knots </td>" +
            "</tr>" +
            "<tr>" +
            " <td><b>Heading</b></td>" +
            "<td>:</td>" +
            "<td>" +
            coord.heading +
            "</td>" +
            " </tr>" +
            "<tr>" +
            "<td><b>Last Update</b></td>" +
            "<td>:</td>" +
            "<td>" +
            coord.dateTime +
            "</td>" +
            "</tr>" +
            "</table>"
        )
        .openOn(myMap);
    },

    triggerPopup(coord) {
      //console.log(coord);
      $("html, body").animate(
        {
          scrollTop: $("#title_map_sailink").offset().top - 109,
        },
        800
      );
      var myMap = this.$refs.map_sailink.mapObject;
      var popLocation = new L.LatLng(coord.lat, coord.lng);
      myMap.setView(popLocation, 6);
      var popup = L.popup()
        .setLatLng(popLocation)
        .setContent(
          "<table><tr><td><b>Latitude</b></td><td>:</td><td>" +
            coord.lat +
            "</td></tr><tr><td><b>Longitude</b></td><td>:</td><td>" +
            coord.lng +
            "</td></tr><tr>" +
            "<td><b>DMS</b></td><td>:</td>" +
            "<td>" +
            coord.dms +
            "</td>" +
            "</tr>" +
            "<tr>" +
            "<td><b>Speed</b></td>" +
            "<td>:</td>" +
            " <td>" +
            coord.speed +
            "&nbsp;knots </td>" +
            "</tr>" +
            "<tr>" +
            " <td><b>Heading</b></td>" +
            "<td>:</td>" +
            "<td>" +
            coord.heading +
            "</td>" +
            " </tr>" +
            "<tr>" +
            "<td><b>Last Update</b></td>" +
            "<td>:</td>" +
            "<td>" +
            coord.dateTime +
            "</td>" +
            "</tr>" +
            "</table>"
        )
        .openOn(myMap);
    },

    toDegreesMinutesAndSeconds(coordinate, pad) {
      var absolute = Math.abs(coordinate);
      var degrees = Math.floor(absolute);
      var minutesNotTruncated = (absolute - degrees) * 60;
      var minutes = Math.floor(minutesNotTruncated);
      var seconds = Math.floor((minutesNotTruncated - minutes) * 60);
      //eslint-disable-next-line
      return (
        String(degrees).padStart(pad, "0") +
        "°" +
        String(minutes).padStart(2, "0") +
        " ' " +
        String(seconds).padStart(2, "0") +
        '"'
      );
    },

    convertDMS(lat, lng) {
      var latitude = this.toDegreesMinutesAndSeconds(lat, 2);
      var latitudeCardinal = lat >= 0 ? "N" : "S";

      var longitude = this.toDegreesMinutesAndSeconds(lng, 3);
      var longitudeCardinal = lng >= 0 ? "E" : "W";

      return (
        latitude +
        " " +
        latitudeCardinal +
        "-" +
        longitude +
        " " +
        longitudeCardinal
      );
    },

    fetchQdialy(service) {
      this.qdaily = true;
      var data = {
        vessel_id: this.showmaptable.id,
        service: service,
      };
      //console.log(data);
      this.fetchQuota(data);
      //console.log(this.quotaData);
    },

    fullscreen() {
      $(".leaflet-control-fullscreen-button").trigger("click");
    },

    clearMeasure() {
      this.$refs["polylineMeasure"].mapObject._clearAllMeasurements();
      this.etaMiles = 0;
      this.etaDuration = 0;
      this.etaArrival = "";
      this.showRouteData = null;
    },

    handleCount() {
      //console.log("THIS COUNT");
    },

    handleToggle() {
      if (this.ex25) {
        //console.log("FROM MARKER CHECKED");
        //console.log(parseFloat(this.showmaptracking.maptop.lat)),
        //console.log(parseFloat(this.showmaptracking.maptop.lon)),
        this.$refs["map_sailink"].mapObject.fire("click", {
          latlng: L.latLng([
            parseFloat(this.showmaptracking.maptop.lat),
            parseFloat(this.showmaptracking.maptop.lon),
          ]),
        });
      }
    },

    handleFinish() {
      //console.log("ITS FINISH");
      $("#strDraw_btn").click();
    },

    startDraw() {
      this.drawon = !this.drawon;
      if (this.drawon == true && this.showRouteData != null) {
        this.clearMeasure();
      }
      this.$refs["polylineMeasure"].mapObject._toggleMeasure();
      //console.log(this.$refs["polylineMeasure"].mapObject._arrPolylines);
    },

    //    toDegreesMinutesAndSeconds(coordinate, pad) {
    //     var absolute = Math.abs(coordinate);
    //     var degrees = Math.floor(absolute);
    //     var minutesNotTruncated = (absolute - degrees) * 60;
    //     var minutes = Math.floor(minutesNotTruncated);
    //     var seconds = Math.floor((minutesNotTruncated - minutes) * 60);

    //     return String(degrees).padStart(pad, '0') + "&deg " + String(minutes).padStart(2, '0') + "\' " + String(seconds).padStart(2, '0') + "\"";
    // },
    //  convertDMS(lat, lng) {
    //     var latitude = this.toDegreesMinutesAndSeconds(lat, 2);
    //     var latitudeCardinal = lat >= 0 ? "N" : "S";

    //     var longitude = this.toDegreesMinutesAndSeconds(lng, 3);
    //     var longitudeCardinal = lng >= 0 ? "E" : "W";

    //     return latitude + " " + latitudeCardinal + "<br>" + longitude + " " + longitudeCardinal;
    // },

    onCount() {
      var currentLine = this.$refs["polylineMeasure"].mapObject._currentLine;
      var coords = currentLine.circleCoords;
      var toolTipsArr = currentLine.tooltips;
      this.showRouteData = coords.map((item, index) =>
        Object.assign(item, { index })
      );
      this.brRouteData = toolTipsArr;
      //console.log("BRROUTE DATA");
      //console.log(this.brRouteData[1]._icon.childNodes[4].innerText);
      var miles = 0;
      coords.forEach((coor, i) => {
        //console.log("lat = " + coor.lat);
        //console.log("lng = " + coor.lng);
        this.totalDistance = toolTipsArr[i]._icon.childNodes[4].innerText;
        miles = parseFloat(toolTipsArr[i]._icon.childNodes[4].innerText);
      });

      this.etaMiles = miles;
      var duration_raw = miles / this.etaSpeed;
      var duration = duration_raw.toFixed(2);

      //console.log("SPEED == " + this.speed);
      //console.log(miles + " nmi");
      //console.log("DURATION == " + duration + " hours");

      var departDateInput = $("#departure-sailink").val();
      //console.log("DEPARTURE INPUT ===== " + departDateInput);

      // 2018-11-24 10:33:30:0
      var today = new Date(departDateInput);
      var seconds = Math.round(duration * 60 * 60);
      //console.log("seconds == " + seconds);
      //console.log(today.getSeconds());
      today.setSeconds(today.getSeconds() + seconds);
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      var h = today.getHours();
      var i = today.getMinutes();

      if (h < 10) {
        h = "0" + h;
      }

      if (i < 10) {
        i = "0" + i;
      }

      today = dd + "/" + mm + "/" + yyyy + " " + h + ":" + i;
      //console.log("arrival date " + today);
      this.etaDuration = duration;
      this.etaArrival = today;
    },

    countETA() {
      var duration_raw = this.etaMiles / this.etaSpeed;
      var duration = duration_raw.toFixed(2);

      //console.log("SPEED == " + this.speed);
      //console.log(this.etaMiles + " nmi");
      //console.log("DURATION == " + duration + " hours");

      var departDateInput = $("#departure-sailink").val();
      //console.log("DEPARTURE INPUT ===== " + departDateInput);

      // 2018-11-24 10:33:30:0
      var today = new Date(departDateInput);
      var seconds = Math.round(duration * 60 * 60);
      //console.log("seconds == " + seconds);
      //console.log(today.getSeconds());
      today.setSeconds(today.getSeconds() + seconds);
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      var h = today.getHours();
      var i = today.getMinutes();

      if (h < 10) {
        h = "0" + h;
      }

      if (i < 10) {
        i = "0" + i;
      }

      today = dd + "/" + mm + "/" + yyyy + " " + h + ":" + i;
      //console.log("arrival date " + today);
      this.etaDuration = duration;
      this.etaArrival = today;
    },

    customRange() {
      this.dateopen = false;
      var range_date = this.dates.join(" ");
      //console.log(range_date);
      this.showdate(this.datepickerID, range_date);
    },

    createPDF() {
      //console.log(this.showmaptable.vessel_pt);
      var parts = this.showmaptable.vessel_pt.split(" ");
      //console.log(parts);

      let pdfName = parts[0] + "_" + parts[1] + "_Tracking_Reports";
      var doc = new jsPDF({
        orientation: "l",
        unit: "mm",
        format: "a4",
        putOnlyUsedFonts: true,
      });

      doc.setProperties({
        title: pdfName,
        subject: "Its a Subject",
        author: "Me!",
        creator: "My Company Name",
      });

      var ln_status;
      var result = this.tableTracking.map((item, index) =>
        Object.assign(item, { index })
      );
      //console.log(result);
      //console.log(this.tableTracking);

      let info = [];
      result.forEach((element) => {
        if (element.isActive == 1) {
          ln_status = "UP";
        } else {
          ln_status = "DOWN";
        }
        info.push([
          [element.index + 1],
          [element.lat, element.lng, `(` + element.dms + `)`],
          [element.heading],
          [element.speed],
          [element.distance],
          [element.rx_snr],
          [element.modcod],
          [element.tx],
          [element.satnet],
          [element.dateTime],
          [ln_status],
        ]);
      });

      //console.log(info);
      doc.text(this.showmaptable.vessel_pt, 15, 5);
      doc.text("Vessel Tracking Report", 15, 10, { fontSize: 9 });

      autoTable(doc, {
        head: [
          [
            "#",
            "Latitude, Longtitude (DMS)",
            "Heading (Degree)",
            "Speed (Knots)",
            "Distance(Nmi)",
            "RX SNR (db)",
            "RX MODCOD",
            "TX Power(db)",
            "SatNet",
            "Date/Time (GMT+7)",
            "Link Status",
          ],
        ],
        body: info,
        theme: "striped",
      });

      doc.save(pdfName + ".pdf");
      // doc.output("dataurlnewwindow");
    },

    createCSV() {
      //console.log(this.showmaptable.vessel_pt);
      var parts = this.showmaptable.vessel_pt.split(" ");
      //console.log(parts);

      let pdfName = parts[0] + "_" + parts[1] + "_Tracking_Reports";

      var ln_status;
      var tableTracking = this.tableTracking.map((item, index) =>
        Object.assign(item, { index })
      );
      //console.log(tableTracking);

      let data = [];
      let header = [
        ["#"],
        ["latitude"],
        ["longitude"],
        ["DMS"],
        ["Heading (Degree)"],
        ["Speed (Knots)"],
        ["Distance (Nmi)"],
        ["RX SNR (db)"],
        ["RX MODCOD"],
        ["TX Power (db)"],
        ["SatNet"],
        ["Date/Time (GMT+7)"],
        ["Link Status"],
      ];

      tableTracking.forEach((element) => {
        if (element.isActive == 1) {
          ln_status = "UP";
        } else {
          ln_status = "DOWN";
        }
        data.push([
          [element.index + 1],
          [element.lat, element.lng, `(` + element.dms + `)`],
          [element.heading],
          [element.speed],
          [element.distance],
          [element.rx_snr],
          [element.modcod],
          [element.tx],
          [element.satnet],
          [element.dateTime],
          [ln_status],
        ]);
      });

      let csvContent =
        "data:text/csv;charset=utf-8," +
        data.map((e) => e.join(",")).join("\n");

      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", pdfName + ".csv");
      document.body.appendChild(link); // Required for FF
      link.click();
    },

    async showdate(item, range) {
      clearInterval(this.IntervalMoving);
      this.countLength=0;
      const data = {
        id: item,
        range: range,
        token: localStorage.getItem("token"),
      };

      this.showondate(data);
      var mother = this;
        var intervalSeconds = 0.5;
        this.fetchInterval = setInterval(function () {
          mother.initialdata_moving();
        }, intervalSeconds );
    },

    linkStatus(id) {
      const dataLn = {
        id: id,
        token: localStorage.getItem("token"),
      };

      this.lnStatus(dataLn);
    },

    async showwth(vid, msgid, type) {
      this.msg_id_after = msgid;
      const data = {
        id: vid,
        msg_id: msgid,
        type: type,
      };
      this.showweather(data);
    },

    openETA() {
      this.etaControl = !this.etaControl;
      let now = new Date();
      now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
      $("#departure-sailink").val(now.toISOString().slice(0, 16));
      if (this.$refs["map_sailink"].mapObject._isFullscreen != true) {
        this.$refs["map_sailink"].mapObject.toggleFullscreen();
      } else {
        //console.log("ETA ALREADY OPEN");
      }
    },

    removeWeather(dateTime) {
   
      this.$delete(this.showclick_dateTime, dateTime);
      this.$delete(this.weatherData, dateTime);
    },

    async weatherClick(id, msgid, type, dateTime) {
      // this.$delete(this.weatherData, dateTime);
      //console.log(this.weatherData);
    
      this.$set(this.showclick_dateTime, dateTime, dateTime);
      const datawth = {
        id: id,
        msg_id: msgid,
        type: type,
      };
      const response = await axios.post(
        "https://navigatorplus.sailink.id/api/v1/navplus/weather/fetchRow",
        datawth,
        {
          headers: {
            Authorization: "Bearer" + localStorage.getItem("token"),
          },
        }
      );
      //console.log(response);
      this.$set(this.weatherData, dateTime, response.data.data);
      //console.log("weather datanya i fetch baru");
      //console.log(this.weatherData);
    },
  },

  computed: {
    ...mapGetters([
      "sailink_executed",
      "searchVesselID",
      "serviceQuota",
      "quotaData",
      "showmaptable",
      "tableTracking",
      "vesselUsers",
      "ip_adr",
      "showmaptracking",
      "ln_status",
      "weather_data",
      "showmapclick",
      "startFrom",
    ]),

    showingDatafrom() {
      if (this.totalFilter < 1) {
        return 0;
      } else {
        return 1;
      }
    },

    isFullscreen_() {
      return this.map_sailink_fs;
    },

    showingDatato() {
      if (this.totalFilter < this.itemsPerPage) {
        return this.totalFilter;
      } else {
        return this.itemsPerPage;
      }
    },

    showingDatafromUser() {
      if (this.totalFilterUser < 1) {
        return 0;
      } else {
        return 1;
      }
    },

    showingDatatoUser() {
      if (this.totalFilterUser < this.itemsPerPageUser) {
        return this.totalFilterUser;
      } else {
        return this.itemsPerPageUser;
      }
    },

    dateRangeText() {
      return this.dates.join(" ~ ");
    },

    mapConfig() {
      return {
        ...mapSettingsShow,
        center: this.mapCenter,
      };
    },

    mapCenter() {
      return {
        lat: parseFloat(this.showmaptable.maptop.lat),
        lng: parseFloat(this.showmaptable.maptop.lon),
      };
    },
  },
};
</script>

<style lang="scss" scopped>
@import "@/assets/css/showmapsailink.css";
@import "@/assets/css/navigator.css";

#eta-menu-container {
  background-color: #fff;
  border-radius: 3px;
  display: none;
  margin: 5px;
  text-align: left;
  width: auto;
  border: none;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
  padding: 8px;
}

.eta-button {
  font-family: "Poppins";
  width: 80px;
  display: inline-block;
  border-radius: 4px;
  padding: 10px;
  font-weight: 600;
  background-color: #ffffff;
  margin-left: 0px;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
}

.vue2leaflet-map {
  z-index: 1;
}

.leaflet-container.cursor-class {
  cursor: crosshair;
}

.hideControl {
  opacity: 0;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border: none;
  cursor: pointer;
}

.leaflet-bar {
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

.leaflet-control {
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

.leaflet-touch .leaflet-bar {
  border: none;
}

.leaflet-touch .leaflet-bar {
  border: 0px solid rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
}

.routeTable th {
  background-color: #ffff;
  color: #626364;
}

.routeTable th span {
  color: #626364;
}

.image tbody {
  display: flex !important;
  white-space: initial;
  flex-wrap: wrap;
  text-align: center;
  width: 100%;
  padding: 1em 1em 0.5em 0.5em;
  flex-direction: row !important;
}

.mobileimage tbody {
  display: flex;
  white-space: initial;
  flex-wrap: wrap;
  text-align: center;
  width: 160vw;
  padding: 1em 1em 0.5em 0.5em;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  padding: 0;
  transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}

.leaflet-popup-content-wrapper {
  padding: 1px;
  text-align: left;
  border-radius: 0;
  box-shadow: none;
}

.v-dialog {
  box-shadow: none;
  border-radius: 0;
}

.tableHeader_ {
  text-align: left;
  color: #626364;
  font-size: 0.9em;
  height: 3em;
  text-align: center;
}

@media (min-width: 280px) and (max-width: 319px) {
  .userTable_mobile {
    display: block;
  }
  .userTable_desktop {
    display: none;
  }

  .pdfsailink_mobile {
    display: block;
  }

  .csvsailink_mobile {
    display: block;
  }

  .pdfsailink_desktop {
    display: none;
  }

  .csvsailink_desktop {
    display: none;
  }

  .trackingTable_sailinkdesktop {
    display: none;
  }

  .trackingTable_sailinkmobile {
    display: block;
  }

  .satnetbtn_sailinkdesktop {
    display: none;
  }

  .lmapbtn_sailinkmobile {
    display: block;
  }

  .btneta_sailinkdesktop {
    display: none;
  }

  .toolbar_sailinkmobile {
    display: block;
  }

  .toolbar_sailinkdesktop {
    display: none;
  }

  .ETAcard_sailinkmobile{
    display: block;
  }

  .ETAcard_sailinkdesktop{
    display: none;
  }

  .coordinate_sailinkdesktop{
    display: none;
  }

  .coordinate_sailinkmobile{
    display: block;
  }
}

/* Mobile Devices */
@media (min-width: 320px) and (max-width: 480px) {
  .userTable_mobile {
    display: block;
  }
  .userTable_desktop {
    display: none;
  }

  .pdfsailink_mobile {
    display: block;
  }

  .csvsailink_mobile {
    display: block;
  }

  .pdfsailink_desktop {
    display: none;
  }

  .csvsailink_desktop {
    display: none;
  }

  .trackingTable_sailinkdesktop {
    display: none;
  }

  .trackingTable_sailinkmobile {
    display: block;
  }

  .satnetbtn_sailinkdesktop {
    display: none;
  }

  .lmapbtn_sailinkmobile {
    display: block;
  }

  .btneta_sailinkdesktop {
    display: none;
  }

  .toolbar_sailinkmobile {
    display: block;
  }

  .toolbar_sailinkdesktop {
    display: none;
  }

  
  .ETAcard_sailinkmobile{
    display: block;
  }

  .ETAcard_sailinkdesktop{
    display: none;
  }

  .coordinate_sailinkdesktop{
    display: none;
  }

  .coordinate_sailinkmobile{
    display: block;
  }
}

/* iPads, Tablets */
@media (min-width: 481px) and (max-width: 768px) {
  .userTable_mobile {
    display: none;
  }
  .userTable_desktop {
    display: block;
  }

  .pdfsailink_mobile {
    display: none;
  }

  .csvsailink_mobile {
    display: none;
  }

  .pdfsailink_desktop {
    display: block;
  }

  .csvsailink_desktop {
    display: block;
  }

  .trackingTable_sailinkdesktop {
    display: block;
  }

  .trackingTable_sailinkmobile {
    display: none;
  }

  .satnetbtn_sailinkdesktop {
    display: block;
  }

  .lmapbtn_sailinkmobile {
    display: none;
  }

  .btneta_sailinkdesktop {
    display: block;
  }
  .toolbar_sailinkmobile {
    display: none;
  }

  .toolbar_sailinkdesktop {
    display: block;
  }

  
  .ETAcard_sailinkmobile{
    display: none;
  }

  .ETAcard_sailinkdesktop{
    display: block;
  }

  .coordinate_sailinkdesktop{
    display: block;
  }

  .coordinate_sailinkmobile{
    display: none;
  }
}

/* Small screens, laptops */
@media (min-width: 769px) and (max-width: 1024px) {
  .userTable_mobile {
    display: none;
  }
  .userTable_desktop {
    display: block;
  }

  .pdfsailink_mobile {
    display: none;
  }

  .csvsailink_mobile {
    display: none;
  }

  .pdfsailink_desktop {
    display: block;
  }

  .csvsailink_desktop {
    display: block;
  }

  .trackingTable_sailinkdesktop {
    display: block;
  }

  .trackingTable_sailinkmobile {
    display: none;
  }

  .satnetbtn_sailinkdesktop {
    display: block;
  }

  .lmapbtn_sailinkmobile {
    display: none;
  }

  .btneta_sailinkdesktop {
    display: block;
  }

  .toolbar_sailinkmobile {
    display: none;
  }

  .toolbar_sailinkdesktop {
    display: block;
  }

  
  .ETAcard_sailinkmobile{
    display: none;
  }

  .ETAcard_sailinkdesktop{
    display: block;
  }

  .coordinate_sailinkdesktop{
    display: block;
  }

  .coordinate_sailinkmobile{
    display: none;
  }
}

/* Desktops, large screens */
@media (min-width: 1025px) and (max-width: 1200px) {
  .userTable_mobile {
    display: none;
  }
  .userTable_desktop {
    display: block;
  }

  .pdfsailink_mobile {
    display: none;
  }

  .csvsailink_mobile {
    display: none;
  }

  .pdfsailink_desktop {
    display: block;
  }

  .csvsailink_desktop {
    display: block;
  }

  .trackingTable_sailinkdesktop {
    display: block;
  }

  .trackingTable_sailinkmobile {
    display: none;
  }
  .satnetbtn_sailinkdesktop {
    display: block;
  }

  .lmapbtn_sailinkmobile {
    display: none;
  }

  .btneta_sailinkdesktop {
    display: block;
  }

  .toolbar_sailinkmobile {
    display: none;
  }

  .toolbar_sailinkdesktop {
    display: block;
  }

  
  .ETAcard_sailinkmobile{
    display: none;
  }

  .ETAcard_sailinkdesktop{
    display: block;
  }

  .coordinate_sailinkdesktop{
    display: block;
  }

  .coordinate_sailinkmobile{
    display: none;
  }
}

/* Extra large screens / TV */
@media screen and (min-width: 1201px) {
  .userTable_mobile {
    display: none;
  }
  .userTable_desktop {
    display: block;
  }

  .pdfsailink_mobile {
    display: none;
  }

  .csvsailink_mobile {
    display: none;
  }

  .pdfsailink_desktop {
    display: block;
  }

  .csvsailink_desktop {
    display: block;
  }

  .trackingTable_sailinkdesktop {
    display: block;
  }

  .trackingTable_sailinkmobile {
    display: none;
  }

  .satnetbtn_sailinkdesktop {
    display: block;
  }

  .lmapbtn_sailinkmobile {
    display: none;
  }

  .btneta_sailinkdesktop {
    display: block;
  }

  .toolbar_sailinkmobile {
    display: none;
  }

  .toolbar_sailinkdesktop {
    display: block;
  }

  .ETAcard_sailinkmobile{
    display: none;
  }

  .ETAcard_sailinkdesktop{
    display: block;
  }

  .coordinate_sailinkdesktop{
    display: block;
  }

  .coordinate_sailinkmobile{
    display: none;
  }


  
}


.v-data-table--mobile > .v-data-table__wrapper .image tbody {
    display: flex;
    flex-direction: row !important;
}


</style>
